import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewChildren, QueryList, effect } from '@angular/core';
import { NavBarComponent } from '../../../shared/components/nav-bar/nav-bar.component';
import { EnableModalComponent } from '../../../shared/components/enable-modal/enable-modal.component';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiService } from '../../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../../services/auth.service';
import { ToastService } from '../../../services/toast.service';
import { Subscription } from 'rxjs';
import { SocketService } from '../../../services/socket.service';
import { BookmarkService } from '../../../services/bookmark.service';
import { ModalHelperComponent } from '../../../shared/components/modal-helper/modal-helper.component';
import { WalletService } from '../../../services/wallet.service';
import { ActivityTrade, parseActivityTrade } from '../../../common/utils/activity-trade';
import { shortenWalletAddress } from '../../../common/utils/wallet-address';
import { Web3ServiceService } from '../../../services/web3-service.service';
import { Web2ServiceService } from '../../../services/web2-service.service';
import { environment } from '../../../../environments/environment';
import { parseUnits } from 'viem';
import { firstValueFrom } from 'rxjs';
import { TypedDataEncoder } from "ethers";
import { POSITION_SORT_OPTIONS } from '../../../common/constants/common.constants';
import { POSITION_STATUS_OPTIONS, ERROR_MESSAGES, OrderSide, MarketTab, PositionStatus, MIN_AMOUNT_OPTIONS } from '../../../common/constants/common.constants';
import { ChartComponent } from '../chart/chart.component';
import { ResolutionState } from '../../../common/constants/common.constants';
import { ExpirationType } from '../../../common/constants/common.constants';
import { ChangeDetectorRef } from '@angular/core';
import { SortDirection } from '../../../common/constants/common.constants';
import { WholeNumberOnlyDirective } from '../../../shared/directives/whole-number.directive';
import { DropdownPlacement, measureDropdownPlacement, PageScrollLock } from '../../../common/utils/dropdown-viewport';

interface Holder {
  user_id: string;
  user_name: string;
  shares: number;
  profile_picture?: string;
  joined_at?: string;
  created_at?: string;
  position_value?: number | string;
  profit_loss?: number | string;
  volume?: number | string;
  avg_buy_price?: number | string;
}

interface OutcomeData {
  outcome_title: string;
  top_holders: Holder[];
}

interface TopHoldersResponse {
  status_code: number;
  message: string;
  data: OutcomeData[];
}

interface ChartPoint {
  time: number;
  value: number;
}

/** Tallest the short filter lists get - a few rows is all they ever hold */
const SHORT_MENU_CAP = 240;
/** Height those lists refuse to shrink below before opening upwards instead */
const SHORT_MENU_MIN = 120;

/** Hex characters an activity row keeps after the 0x, e.g. 0x0f51...2ceb */
const ACTIVITY_ADDRESS_HEX = 4;

/** The popups on this page, each of which holds the background still while open */
type PopupName =
  | 'commentsFilter'
  | 'date'
  | 'all'
  | 'minAmount'
  | 'limitType'
  | 'positionStatus'
  | 'positionSort'
  | 'expiration'
  | 'holdersOutcome'
  | 'outcomeList'
  | 'mobileTradeSheet';

@Component({
  selector: 'app-details',
  standalone: true,
  imports: [NavBarComponent, RouterModule, ChartComponent, CommonModule, FormsModule, ReactiveFormsModule, ModalHelperComponent, WholeNumberOnlyDirective],
  templateUrl: './details.component.html',
  styleUrl: './details.component.css'
})

export class DetailsComponent implements OnInit, OnDestroy {
  isOrderBookOpen: boolean = false;
  @ViewChild('rulesContent') rulesContent!: ElementRef;
  @ViewChild('expirationList') expirationList?: ElementRef<HTMLElement>;
  @ViewChild('minAmtTrigger') minAmtTrigger?: ElementRef<HTMLElement>;
  @ViewChild('holdersOutcomeTrigger') holdersOutcomeTrigger?: ElementRef<HTMLElement>;
  @ViewChildren('orderBookContainer') orderBookContainer!: QueryList<ElementRef>;
  @ViewChildren('middleWrapper') middleInfo!: QueryList<ElementRef>;
  activeTab: MarketTab = MarketTab.COMMENTS;
  selectedFilter: string = 'Newest';
  liked: boolean = false;
  isBookmarked: boolean = false;
  bookmarkSubscription: Subscription | undefined;
  isExpanded = false;
  isOverflowing = false;
  isOpen: boolean = false;
  showOrderBook = false;
  selectedIndex: number | null = null;
  activeSide: string | null = null;
  activeTabs: { [key: number]: string } = {};
  userNonce: bigint | null = null;
  activityList: any[] = [];
  yesPositions: any[] = [];
  noPositions: any[] = [];
  outcomes: any[] = [];
  statusOptions = POSITION_STATUS_OPTIONS;
  sortOptions = POSITION_SORT_OPTIONS;
  bids: any[] = [];
  asks: any[] = [];
  outcomeId: string = '';
  selectedOutcomeId!: string;
  orderBook: any;
  selectedStatus = PositionStatus.ALL;
  selectedSort = SortDirection.DESC;
  PositionStatus = PositionStatus;
  SortDirection = SortDirection;
  totalBidValue: number = 0;
  spread: number = 0;
  lastPrice: number = 0;
  totalBid: number = 0;
  maxDepth: number = 0;
  marketPriceSub!: Subscription;
  priceSub!: Subscription;
  lastPriceYes: number = 50;
  lastPriceNo: number = 50;
  priceHistoryData: any = {
    yes: [],
    no: []
  };
  userData: any;
  minAmountOptions = [
    { label: 'Min Amount', value: null },
    { label: '$10', value: 10 },
    { label: '$100', value: 100 },
    { label: '$1,000', value: 1000 },
    { label: '$10,000', value: 10000 },
    { label: '$100,000', value: 100000 }
  ];
  selectedMinAmount: number | null = null;
  /** Tallest the min-amount list gets when there is room to spare */
  private readonly minAmtDropdownCap = 280;
  minAmtDropdownMaxHeight = this.minAmtDropdownCap;
  minAmtDropUp = false;


  selectedLimitType: string = 'Limit'; // Default value
  selectedAction: string = 'Buy'; // Buy or Sell
  selectedOption: string | null = null; // Dynamically set to outcome title
  limitPrice: number = 0;
  shares: number = 0;
  total: number = 0;
  toWin: number = 0;
  showSellTooltip: boolean = false;
  maxAvailableShares: number = 1000;
  tradeButtonClicked: boolean = false;
  showProfitTooltip: boolean = false;
  profit: number = 0;
  changePercentage: number = 0;
  multiplier: number = 0;
  matchingIncrements = [];
  isSharesFocused: boolean = false;
  isSharesHovered: boolean = false;
  investForm!: FormGroup;
  private blurTimeout: any;
  amount: number = 0;
  isAmountFocused: boolean = false;
  selectExpirationType: string = "";
  private recentlyPostedCommentIds: Set<string> = new Set();
  private COMMENT_DEDUP_TIMEOUT = 5000; // 5 seconds to account for socket delay

  private amountBlurTimeout: any;
  enableTradingModalOpen = false;
  marketID: string = "";
  usdcBalance: any = 0;
  availableCashBalance: any = 0;
  private portfolioGlobalSubscription: Subscription | undefined;
  marketData: any;
  commentData: any[] = [];
  commentForm: FormGroup = new FormGroup({
    comment: new FormControl("", [Validators.required])
  })
  selectedOutcome: { id: string; title: string } | null = null;
  private likeSub!: Subscription;
  private unlikeSub!: Subscription;
  private newCommentSub!: Subscription;
  private orderBookStreamSub: Subscription | undefined;
  hoveredHolder: Holder | null = null;
  isHolderTooltipVisible: boolean = false;
  holderTooltipLeft: number = 0;
  holderTooltipTop: number = 0;
  holderTooltipPlacement: 'right' | 'top' | 'left' | 'bottom' = 'right';
  private holderTooltipShowTimeout: ReturnType<typeof setTimeout> | null = null;
  private holderTooltipHideTimeout: ReturnType<typeof setTimeout> | null = null;
  private readonly HOLDER_TOOLTIP_DELAY = 150;
  private readonly HOLDER_TOOLTIP_FADE_DURATION = 180;
  private readonly HOLDER_TOOLTIP_WIDTH = 296;
  private readonly HOLDER_TOOLTIP_HEIGHT = 158;
  private readonly HOLDER_TOOLTIP_GAP = 14;

  // Pagination properties (25 item limit per page)
  private readonly PAGE_SIZE = 25;

  // Comments pagination
  commentsPage: number = 1;
  hasMoreComments: boolean = true;
  isLoadingComments: boolean = false;

  // Activity pagination
  activityPage: number = 1;
  hasMoreActivity: boolean = true;
  isLoadingActivity: boolean = false;

  // Top Holders dynamic storage
  public outcomesHolders: any[] = [];
  isLoadingHolders: boolean = false;

  // Top Holders outcome picker — multi-outcome, mobile only (<= 575px).
  // Desktop keeps every outcome column on screen, so it ignores this.
  isHoldersMobileView: boolean = false;
  selectedHolderOutcomeTitle: string | null = null;
  /** Tallest the outcome list gets when there is room to spare */
  private readonly holdersOutcomeDropdownCap = 260;
  holdersOutcomeDropdownMaxHeight = this.holdersOutcomeDropdownCap;
  holdersOutcomeDropUp = false;

  // Positions pagination (separate for YES and NO)
  yesPositionsPage: number = 1;
  hasMoreYesPositions: boolean = true;
  isLoadingYesPositions: boolean = false;

  noPositionsPage: number = 1;
  hasMoreNoPositions: boolean = true;
  isLoadingNoPositions: boolean = false;

  MarketTab = MarketTab;
  public expirationOptions: string[] = [
    ExpirationType.FIVE_MINUTES,
    ExpirationType.ONE_HOUR,
    ExpirationType.TWELVE_HOURS,
    ExpirationType.TWENTY_FOUR_HOURS,
    ExpirationType.END_OF_DAY
  ];
  marketContext: any = null;
  isLoadingContext: boolean = false;
  isGeneratingContext: boolean = false;

  hasCentered: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private auth: AuthService,
    private service: ApiService,
    private toastr: ToastService,
    private socketservice: SocketService,
    private walletService: WalletService,
    private web3service: Web3ServiceService,
    private cdRef: ChangeDetectorRef,
    private bookmarkService: BookmarkService,
    private router: Router,
    private web2Service: Web2ServiceService,
    private location: Location
  ) {
    // The Trade button is disabled while signed out, so the view has to be
    // re-rendered the moment the session appears — that is what turns the
    // button back on straight after login, with no reload.
    effect(() => {
      this.auth.isLoggedIn();
      this.cdRef.markForCheck();
    });
  }

  // Mobile header back button (<= 575px)
  goBack(): void {
    this.location.back();
  }

  private scrollLock = new PageScrollLock();

  /**
   * Every popup on the page, in one place. Each is still reached through the
   * property of the same name it always had, so opening or closing one anywhere
   * in the component keeps the page's scroll lock in step - see setPopup().
   */
  private popups: Record<PopupName, boolean> = {
    commentsFilter: false,
    date: false,
    all: false,
    minAmount: false,
    limitType: false,
    positionStatus: false,
    positionSort: false,
    expiration: false,
    holdersOutcome: false,
    outcomeList: false,
    mobileTradeSheet: false
  };

  /** Comments sort — Newest / Most Liked */
  get dropdownOpen(): boolean { return this.popups.commentsFilter; }
  set dropdownOpen(open: boolean) { this.setPopup('commentsFilter', open); }

  get showDateDropdown(): boolean { return this.popups.date; }
  set showDateDropdown(open: boolean) { this.setPopup('date', open); }

  get showAllDropdown(): boolean { return this.popups.all; }
  set showAllDropdown(open: boolean) { this.setPopup('all', open); }

  get showMinAmtDropdown(): boolean { return this.popups.minAmount; }
  set showMinAmtDropdown(open: boolean) { this.setPopup('minAmount', open); }

  get showLimitDropdown(): boolean { return this.popups.limitType; }
  set showLimitDropdown(open: boolean) { this.setPopup('limitType', open); }

  /** Positions status — All / Open / Closed */
  get showStatusFilterDropdown(): boolean { return this.popups.positionStatus; }
  set showStatusFilterDropdown(open: boolean) { this.setPopup('positionStatus', open); }

  /** Positions order — Desc / Asc */
  get showSortFilterDropdown(): boolean { return this.popups.positionSort; }
  set showSortFilterDropdown(open: boolean) { this.setPopup('positionSort', open); }

  get showExpirationDropdown(): boolean { return this.popups.expiration; }
  set showExpirationDropdown(open: boolean) { this.setPopup('expiration', open); }

  /** Top Holders outcome picker — multi-outcome, mobile only */
  get showHoldersOutcomeDropdown(): boolean { return this.popups.holdersOutcome; }
  set showHoldersOutcomeDropdown(open: boolean) { this.setPopup('holdersOutcome', open); }

  /** Multi-outcome sheet: outcome picker replaces the order form while open */
  get showOutcomeListPopup(): boolean { return this.popups.outcomeList; }
  set showOutcomeListPopup(open: boolean) { this.setPopup('outcomeList', open); }

  /** Mobile trade sheet (<= 575px) — the side panel slides up as a bottom sheet */
  get isMobileTradeSheetOpen(): boolean { return this.popups.mobileTradeSheet; }
  set isMobileTradeSheetOpen(open: boolean) { this.setPopup('mobileTradeSheet', open); }

  /**
   * Records a popup's state and holds the page still while any of them is open.
   * A popup that scrolls inside itself would otherwise drag the page along once
   * the scroll runs past its end, and a page sliding out from under an open
   * popup leaves it detached from the control it belongs to.
   * @param name - Which popup changed
   * @param open - Whether it is now open
   */
  private setPopup(name: PopupName, open: boolean): void {
    // Closing what is already closed is the common case - every document click
    // clears most of these - so nothing is recomputed unless something moved
    if (this.popups[name] === open) {
      return;
    }

    this.popups[name] = open;
    this.scrollLock.set(Object.values(this.popups).some(isOpen => isOpen));
  }

  /** Shuts every popup and gives the page back its scrolling */
  private closeAllPopups(): void {
    (Object.keys(this.popups) as PopupName[]).forEach(name => this.setPopup(name, false));
  }

  /**
   * Where each of the short filter lists opens, keyed by popup. They are only a
   * few rows tall, but the page is held still while one is open, so a list that
   * ran past the bottom of the screen could not be scrolled back into view.
   */
  menuPlacement: Partial<Record<PopupName, DropdownPlacement>> = {};

  /**
   * Measures a list against the room its own button has left on screen.
   * @param name - Which popup is opening
   * @param event - The click that opened it, used to find the button
   */
  private placePopup(name: PopupName, event?: Event): void {
    const trigger = (event?.target as HTMLElement | null)?.closest('button');
    if (!trigger) {
      return;
    }

    this.menuPlacement[name] = measureDropdownPlacement(trigger, {
      maxHeight: SHORT_MENU_CAP,
      minHeight: SHORT_MENU_MIN
    });
  }

  // Every tradable market swaps the side panel for a bottom sheet on mobile
  usesMobileTradeSheet(): boolean {
    return !this.isMarketWinnerDeclared();
  }

  // Only binary markets get the pinned outcome bar — multi-outcome opens the
  // sheet from the Buy Yes / Buy No buttons on each outcome row instead.
  usesMobileTradeBar(): boolean {
    return !this.isMultiOutcomeFlag() && !this.isMarketWinnerDeclared();
  }

  openMobileTradeSheet(outcomeTitle: string): void {
    this.setOption(outcomeTitle);
    this.isMobileTradeSheetOpen = true;
  }

  /**
   * Dismissing the sheet throws away whatever was typed into the order form, so
   * it always reopens fresh. A close driven by the viewport growing past the
   * breakpoint passes false: the same form stays on screen as the desktop side
   * panel, and a resize is no reason to wipe it.
   */
  closeMobileTradeSheet(clearInputs: boolean = true): void {
    if (!this.isMobileTradeSheetOpen) return;
    this.isMobileTradeSheetOpen = false;
    this.showOutcomeListPopup = false;
    this.showExpirationDropdown = false;

    if (clearInputs) {
      this.clearTradeInputs();
    }
  }

  // Amount, shares and expiry the user typed, plus the quick-action rows that
  // the focus flags keep open while a field is being edited
  private clearTradeInputs(): void {
    clearTimeout(this.blurTimeout);
    clearTimeout(this.amountBlurTimeout);
    clearTimeout(this.marketSellBlurTimeout);
    this.isAmountFocused = false;
    this.isSharesFocused = false;
    this.isMarketSellSharesFocused = false;
    this.resetForm();
  }

  private isMobileViewport(): boolean {
    // Negating the desktop query is the exact complement of the stylesheets'
    // (width < 576px), so no fractional width can be mobile here and desktop there
    return typeof window !== 'undefined' && !window.matchMedia('(min-width: 576px)').matches;
  }

  // Buy Yes / Buy No on a multi-outcome row. On mobile this opens the trade
  // sheet for that outcome and deliberately leaves the order book alone —
  // only a tap on the outcome card itself expands it. On desktop it toggles the
  // row's order book: the same side twice collapses it again.
  onRowSideClick(index: number, row: any, side: 'yes' | 'no', event: Event): void {
    event.stopPropagation();

    if (this.isMobileViewport()) {
      this.openOutcomeTradeSheet(row, side);
      return;
    }

    if (this.selectedIndex === index && this.activeSide === side) {
      this.closeRow();
      return;
    }

    this.openRow(index, side);
  }

  openOutcomeTradeSheet(row: any, side: 'yes' | 'no'): void {
    this.applySheetOutcome(row, side);
    this.selectedAction = 'Buy';
    this.showOutcomeListPopup = false;
    this.showExpirationDropdown = false;
    this.isMobileTradeSheetOpen = true;
  }

  // Yes / No toggle inside the multi-outcome sheet
  setMultiOutcomeSide(side: 'yes' | 'no'): void {
    this.applySheetOutcome(this.selectedOutcome, side);
  }

  // Picking a different outcome from the sheet's outcome list (keeps the side)
  selectSheetOutcome(row: any): void {
    this.applySheetOutcome(row, (this.activeSide as 'yes' | 'no') || 'yes');
    this.showOutcomeListPopup = false;
  }

  toggleOutcomeListPopup(event?: Event): void {
    event?.stopPropagation();
    this.showOutcomeListPopup = !this.showOutcomeListPopup;
    if (this.showOutcomeListPopup) this.showExpirationDropdown = false;
  }

  closeOutcomeListPopup(event?: Event): void {
    event?.stopPropagation();
    this.showOutcomeListPopup = false;
  }

  // True while the outcome picker is covering the order form
  isOutcomeListOpen(): boolean {
    return this.isMultiOutcomeFlag() && this.isMobileTradeSheetOpen && this.showOutcomeListPopup;
  }

  // Side label shown next to the action in the sheet header
  getSheetSideTitle(): string {
    return this.activeSide === 'no' ? 'No' : 'Yes';
  }

  // Points the order slip at an outcome/side without touching the order book row
  private applySheetOutcome(row: any, side: 'yes' | 'no'): void {
    if (!row) return;

    this.activeSide = side;
    this.selectedOutcome = row;
    this.selectedOutcomeId = row.id;
    this.selectedOption = row.title;
    this.tradeButtonClicked = false;

    const price = side === 'no' ? this.getRowNoPrice(row) : this.getRowYesPrice(row);
    this.limitPrice = Math.round(price * 10) / 10 || 50;

    if (this.selectedOutcomeId) {
      this.loadOrderBook(this.selectedOutcomeId);
    }

    this.calculateTotal();
    this.calculateToWin();
  }

  ngOnInit() {
    this.initializeForm();
    this.investForm.get('shares')?.valueChanges.subscribe((value: any) => {
      this.updateShares(value);
    });

    this.investForm.get('marketSellShares')?.valueChanges.subscribe((value: any) => {
      this.updateMarketSellShares(value);
    });

    this.scrollToTop();
    // Default UI setup FIRST
    this.activeTabs = {};
    this.selectedAction = 'Buy';
    this.selectedLimitType = 'Limit';
    this.selectedOption = 'yes';

    // Set selected option from query parameters if available
    const outcomeParam = this.route.snapshot.queryParamMap.get('outcome');
    if (outcomeParam) {
      this.selectedOption = outcomeParam;
    }

    // Pre-fill sell order from portfolio navigation
    const actionParam = this.route.snapshot.queryParamMap.get('action');
    const orderTypeParam = this.route.snapshot.queryParamMap.get('orderType');
    if (actionParam && actionParam.toLowerCase() === 'sell') {
      this.selectedAction = 'Sell';
      this.selectedLimitType = orderTypeParam?.toLowerCase() === 'market' ? 'Market' : 'Limit';
    }

    const sharesParam = this.route.snapshot.queryParamMap.get('shares');
    if (sharesParam) {
      const parsedShares = parseFloat(sharesParam);
      if (!isNaN(parsedShares) && parsedShares > 0) {
        if (this.selectedAction === 'Sell' && this.selectedLimitType === 'Market') {
          this.marketSellShares = parsedShares;
          this.investForm?.patchValue({ marketSellShares: parsedShares });
        } else {
          this.shares = parsedShares;
          this.investForm?.patchValue({ shares: parsedShares });
        }
      }
    }

    const limitPriceParam = this.route.snapshot.queryParamMap.get('limitPrice');
    if (limitPriceParam && this.selectedLimitType === 'Limit') {
      const parsedPrice = parseFloat(limitPriceParam);
      if (!isNaN(parsedPrice) && parsedPrice > 0) {
        // current_price from API is typically 0-1 range, convert to cents (0-100)
        this.limitPrice = parsedPrice <= 1 ? Math.round(parsedPrice * 100) : parsedPrice;
      }
    }

    // Default prices (so UI never shows 0)
    this.lastPriceYes = 0;
    this.lastPriceNo = 0;

    this.isHoldersMobileView = this.isMobileViewport();

    this.calculateTotal();

    const userData = this.auth.getUserData();

    // Route params (IMPORTANT - everything dependent on marketID inside this)
    this.route.params.subscribe(params => {
      this.marketID = params['slug'];

      // 1. FORCE CLEAN SLATE
      this.limitPrice = 0;
      this.lastPriceYes = 0;
      this.lastPriceNo = 0;
      this.marketData = null; // Clear old data immediately
      this.outcomes = [];
      this.outcomesHolders = [];
      this.selectedHolderOutcomeTitle = null;
      this.showHoldersOutcomeDropdown = false;
      this.commentData = [];

      if (this.priceSub) this.priceSub.unsubscribe();
      if (this.portfolioGlobalSubscription) this.portfolioGlobalSubscription.unsubscribe();
      if (this.bookmarkSubscription) this.bookmarkSubscription.unsubscribe();

      if (!this.marketID) return;

      // Initialize bookmark state from service
      this.isBookmarked = this.bookmarkService.isBookmarked(this.marketID);

      // Subscribe to bookmark state changes for reactive updates
      if (this.bookmarkSubscription) {
        this.bookmarkSubscription.unsubscribe();
      }
      this.bookmarkSubscription = this.bookmarkService.bookmarkedMarkets$.subscribe(() => {
        this.isBookmarked = this.bookmarkService.isBookmarked(this.marketID);
      });

      // API calls
      this.getMarketDetail();
      this.loadTopHolders(this.marketID);
      this.loadActivity();
      this.loadPositions();
      this.getCommentsList();
      this.getMarketContext();

      //  Start streaming ONLY after marketID is available
      this.socketservice.streamMarketPrices(this.marketID);

      // Subscribe to the global stream managed by AuthService
      this.portfolioGlobalSubscription = this.auth.portfolioSummary$.subscribe({
        next: (res: any) => {
          if (!res) return;
          // console.log("Details UI Update from Global Stream:", res);
          // cash_balance from the stream is the ground truth
          this.usdcBalance = res.portfolio_value ?? res.data?.portfolio_value ?? this.usdcBalance;
          this.availableCashBalance = res.available_to_trade ?? res.data?.available_to_trade ?? res.cash_balance ?? res.data?.cash_balance ?? this.availableCashBalance;
          this.cdRef.detectChanges();
        }
      });

      //  Subscribe to price updates
      this.priceSub = this.socketservice.prices$.subscribe(
        (pricesObj: any) => {
          if (!pricesObj || Object.keys(pricesObj).length === 0) return;

          let yesPrice = null;
          let noPrice = null;

          // Resolve outcome-specific prices dynamically
          if (this.marketData?.outcomes && this.marketData.outcomes.length >= 2) {
            const yesOutcome = this.marketData.outcomes[0];
            const noOutcome = this.marketData.outcomes[1];

            if (yesOutcome && pricesObj[yesOutcome.id] !== undefined) yesPrice = Number(pricesObj[yesOutcome.id]);
            if (noOutcome && pricesObj[noOutcome.id] !== undefined) noPrice = Number(pricesObj[noOutcome.id]);
          } else {
            // Fallback strategy if marketData hasn't loaded: check if the fallback variables exist
            const prices = Object.values(pricesObj);
            if (prices.length >= 2) {
              yesPrice = Number(prices[0]);
              noPrice = Number(prices[1]);
            }
          }

          if (yesPrice !== null) {
            this.lastPriceYes = yesPrice <= 1 ? Math.round(yesPrice * 100) : yesPrice;
          }
          if (noPrice !== null) {
            this.lastPriceNo = noPrice <= 1 ? Math.round(noPrice * 100) : noPrice;
          }

          //  Set initial price if still 0 or at default 50
          if (!this.limitPrice || this.limitPrice === 0 || this.limitPrice === 50) {
            this.limitPrice =
              this.isFirstOutcomeSelected()
                ? this.lastPriceYes
                : this.lastPriceNo;
          }

          //  Auto update ONLY for Market orders
          if (this.selectedLimitType === 'Market') {
            this.limitPrice =
              this.isFirstOutcomeSelected()
                ? this.lastPriceYes
                : this.lastPriceNo;
          }

          this.loadPriceHistory();
          // Provide an abstracted format to existing functions which might expect the specific object structure
          this.updateOrderBookPrices({ yes: this.lastPriceYes, no: this.lastPriceNo });
          this.calculateToWin();
        }
      );
    });

    //  Socket listeners (no change)
    this.likeSub = this.socketservice
      .listen<any>('COMMENT_LIKED')
      .subscribe(socketData => {
        const matchedComment = this.commentData.find(
          comment => comment.id === socketData.comment_id
        );

        if (matchedComment) {
          matchedComment.likes_count = socketData.likes_count;
          matchedComment.likedByMe = true;
        }
      });

    this.unlikeSub = this.socketservice
      .listen<any>('COMMENT_UNLIKED')
      .subscribe(socketData => {
        const matchedComment = this.commentData.find(
          comment => comment.id === socketData.comment_id
        );

        if (matchedComment) {
          matchedComment.likes_count = socketData.likes_count;
          matchedComment.likedByMe = false;
        }
      });

    this.newCommentSub = this.socketservice
      .listen<any>('NEW_COMMENT')
      .subscribe(socketData => {

        if (!socketData?.comment_id) return;

        // Skip if this comment was just posted by the current user (to avoid duplicates)
        if (this.recentlyPostedCommentIds.has(socketData.comment_id)) {
          this.recentlyPostedCommentIds.delete(socketData.comment_id);
          return;
        }

        const alreadyExists = this.commentData.some(
          comment => comment.id === socketData.comment_id
        );
        if (alreadyExists) return;

        const newComment = {
          id: socketData.comment_id,
          content: socketData.content,
          user_name: socketData.user_name,
          user_id: socketData.user_id,
          profile_picture: socketData.profile_picture,
          created_at: socketData.created_at,
          likes_count: 0,
          likedByMe: false
        };

        this.commentData.unshift(newComment);
      });

    this.fetchUserNonce();
  }

  initializeForm() {
    this.investForm = new FormGroup({
      shares: new FormControl(null),
      marketSellShares: new FormControl(null)
    })
  }

  checkOverflow() {
    if (!this.rulesContent) return;

    const element = this.rulesContent.nativeElement;

    // Use a more robust check for overflow
    const hadClamp = element.classList.contains('line-clamp-3');
    if (!hadClamp) element.classList.add('line-clamp-3');

    // Wait for the browser to apply styles and measure
    setTimeout(() => {
      this.isOverflowing = element.scrollHeight > element.clientHeight;

      // Restore expansion state
      if (this.isExpanded) {
        element.classList.remove('line-clamp-3');
      } else if (!hadClamp && !this.isOverflowing) {
        // If it wasn't clamped and doesn't need to be, remove it
        element.classList.remove('line-clamp-3');
      }

      this.cdRef.detectChanges();
    }, 0);
  }

  ngAfterViewInit() {

    if (this.outcomes?.length) {
      this.selectedOutcomeId = this.outcomes[0].id;

      this.loadOrderBook(this.selectedOutcomeId);
    }
    this.checkOverflow();

  }

  getDisplayText(): string {
    if (!this.selectedAction || !this.selectedOutcome) {
      const defaultOption = this.marketData?.outcomes?.[0]?.title || 'Yes';
      return `Buy ${defaultOption}`;
    }

    return `${this.selectedAction} ${this.selectedOutcome.title}`;
  }

  toggleStatusDropdown(event?: Event) {
    this.showStatusFilterDropdown = !this.showStatusFilterDropdown;
    this.showSortFilterDropdown = false;
    if (this.showStatusFilterDropdown) {
      this.placePopup('positionStatus', event);
    }
  }

  selectStatus(status: { label: string, value: string }) {
    this.selectedStatus = status.value as PositionStatus;
    this.showStatusFilterDropdown = false;
    this.loadPositions();
  }

  toggleSortDropdown(event?: Event) {
    this.showSortFilterDropdown = !this.showSortFilterDropdown;
    this.showStatusFilterDropdown = false;
    if (this.showSortFilterDropdown) {
      this.placePopup('positionSort', event);
    }
  }

  selectSort(sort: { label: string, value: string }) {
    this.selectedSort = sort.value as SortDirection;
    this.showSortFilterDropdown = false;
    this.loadPositions();
  }

  getStatusLabel(): string {
    return this.statusOptions.find(s => s.value === this.selectedStatus)?.label || 'All';
  }

  getSortLabel(): string {
    return this.sortOptions.find(s => s.value === this.selectedSort)?.label || 'Desc';
  }

  async fetchUserNonce() {
    try {
      const userAddress = this.walletService.getAddress();

      if (!userAddress) {
        console.log('Wallet not connected');
        return;
      }

      const nonce = await this.web3service.getUserNonce(userAddress);

      // console.log('User Nonce:', nonce);

      this.userNonce = nonce as bigint;

    } catch (error) {
      console.error('Error fetching nonce:', error);
    }
  }

  private handleCommentUpdate(data: any) {
    if (data && this.commentData) {
      const commentIndex = this.commentData.findIndex(comment => comment.id === data.comment_id);
      if (commentIndex !== -1) {
        this.commentData[commentIndex].likes_count = data.likes_count;
      }
    }
  }

  getFirstLetter(name: string): string {
    if (!name) return '';
    return name.trim().charAt(0).toUpperCase();
  }

  /**
   * Scroll to the top of the page.
   */
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.relative')) {
      this.showStatusFilterDropdown = false;
      this.showSortFilterDropdown = false;
      this.showAllDropdown = false;
      this.showDateDropdown = false;
      this.showMinAmtDropdown = false;
      this.showExpirationDropdown = false;
    }
  }

  copyLink() {
    const baseUrl = environment.FRONTEND_URL;
    const shareUrl = `${baseUrl}details/${this.marketID}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      this.toastr.success('Link copied to clipboard!');
    }).catch(err => {
      console.error('Could not copy text: ', err);
      this.toastr.error('Failed to copy link');
    });
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleMinAmtDropdown() {
    this.showMinAmtDropdown = !this.showMinAmtDropdown;
    if (this.showMinAmtDropdown) {
      this.updateMinAmtDropdownPlacement();
    }
  }

  /**
   * Fits the min-amount list into the room the trigger actually has. On mobile a
   * tab bar is fixed over the bottom of the page, so the space below the trigger
   * ends at the bar rather than at the viewport edge - without this the last
   * options sit behind it. When the space above is the roomier of the two, the
   * list opens upwards instead.
   */
  private updateMinAmtDropdownPlacement(): void {
    const trigger = this.minAmtTrigger?.nativeElement;
    if (!trigger) {
      return;
    }

    const placement = measureDropdownPlacement(trigger, { maxHeight: this.minAmtDropdownCap });
    this.minAmtDropUp = placement.above;
    this.minAmtDropdownMaxHeight = placement.maxHeight;
  }

  selectMinAmount(option: { label: string, value: number | null }) {
    this.selectedMinAmount = option.value;
    this.showMinAmtDropdown = false;
    this.loadActivity();
  }

  getMinAmountLabel(): string {
    return this.minAmountOptions.find(o => o.value === this.selectedMinAmount)?.label || 'Min Amount';
  }
  getMarketDetail(): void {
    // Reset limit price when fetching new detail to ensure sync
    this.limitPrice = 0;
    // console.log("Fetching market details for ID:", this.marketID);

    this.service.getMarketDetail(this.marketID).subscribe(
      (result: any) => {

        this.marketData = result.data;

        // Sync bookmark state with the formal ID from API
        if (this.marketData && this.marketData.id) {
          this.isBookmarked = this.bookmarkService.isBookmarked(this.marketData.id);
        }

        // Security check: Restrict access if the market is set to inactive by admin
        const statusVal = (this.marketData?.status || this.marketData?.market_status || '').toString().toLowerCase();
        const typeVal = (this.marketData?.market_type || '').toString().toLowerCase();

        if (statusVal === 'inactive' || typeVal === 'inactive') {
          this.toastr.error("This market is currently inactive.");
          this.router.navigate(['/404'], { skipLocationChange: true });
          return;
        }

        setTimeout(() => {
          this.checkOverflow();
        }, 100);
        if (this.marketData.outcomes && this.marketData.outcomes.length > 0) {
          // Extract initial prices from outcomes
          // Extract initial prices from outcomes
          const yesOutcome = this.marketData.outcomes[0];
          const noOutcome = this.marketData.outcomes[1];

          if (yesOutcome && yesOutcome.price) {
            const p = Number(yesOutcome.price);
            this.lastPriceYes = p <= 1 ? Math.round(p * 100) : p;
          }
          if (noOutcome && noOutcome.price) {
            const p = Number(noOutcome.price);
            this.lastPriceNo = p <= 1 ? Math.round(p * 100) : p;
          }

          // Initialize selection based on query param or default ('yes')
          // Initialize selection based on query param or default (first outcome)
          const defaultTitle = this.marketData.outcomes[0]?.title;
          this.setOption(this.selectedOption || defaultTitle || 'yes');

          // Fallback if setOption didn't find a matching "Yes" or "No" outcome (e.g. for multi-choice markets)
          if (!this.selectedOutcome) {
            this.selectedOutcome = this.marketData.outcomes[0];
            this.selectedOutcomeId = this.marketData.outcomes[0].id;
          }

          // Explicitly load price history once outcome ID is available
          this.loadPriceHistory();
        }

        this.loadOrderBook();

      },
      (error: HttpErrorResponse) => {
        console.error(error);
        this.toastr.error("Market not found or invalid URL");
        this.router.navigate(['/404'], { skipLocationChange: true });
      }
    );
  }
  getCommentsList(isLoadMore: boolean = false): void {
    // Reset pagination when doing a fresh load
    if (!isLoadMore) {
      this.commentsPage = 1;
      this.commentData = [];
      this.hasMoreComments = true;
    }

    if (this.isLoadingComments || !this.hasMoreComments) {
      return;
    }

    this.isLoadingComments = true;
    const params = {
      market_id: this.marketID,
      page: this.commentsPage,
      limit: this.PAGE_SIZE
    };

    this.service
      .getMarketComments(params)
      .subscribe((result: any) => {
        const newComments = (result.data.results || []).map((comment: any) => ({
          ...comment,
          profile_picture: comment.profile_picture || comment.picture || comment.profile_image
        }));

        if (isLoadMore) {
          this.commentData = [...this.commentData, ...newComments];
        } else {
          this.commentData = newComments;
        }

        // Check if there are more records
        this.hasMoreComments = newComments.length === this.PAGE_SIZE;
        this.commentsPage++;
        this.isLoadingComments = false;
      }, (error: HttpErrorResponse) => {
        console.error(error);
        this.isLoadingComments = false;
      });
  }

  /**
   * Parse HTML content safely
   * @param content 
   * @returns 
   */
  parseHTMLContent(content: string | null | undefined): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content || '');
  }

  formatUserId(userId: string): string {
    if (!userId) return 'User';
    if (userId.length <= 12) return userId;
    return userId.substring(0, 6) + '...' + userId.substring(userId.length - 4);
  }

  timeAgo(timestamp: string): string {
    if (!timestamp) return '';

    // Ensure the timestamp is treated as UTC if no offset is present
    let utcTimestamp = timestamp;
    if (!timestamp.includes('Z') && !timestamp.includes('+') && !timestamp.match(/-\d{2}:\d{2}$/)) {
      utcTimestamp += 'Z';
    }

    const now = new Date();
    const date = new Date(utcTimestamp);
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds < 0) return 'just now'; // Handle slight clock skew
    if (seconds < 60) return 'just now';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days}d ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months}mo ago`;
    return `${Math.floor(months / 12)}y ago`;
  }
  // Post lights up in full-strength green as soon as there is something to post
  get hasCommentDraft(): boolean {
    return !!this.commentForm.controls['comment'].value?.trim();
  }

  postComment(): void {
    if (this.commentForm.invalid)
      return;

    if (!this.auth.getSessionToken()) {
      this.auth.sendOperationSignal("login")
      return;
    }

    let obj: any = {
      content: this.commentForm.controls['comment'].value,
      market_id: this.marketID
    };

    this.service
      .postMarketComment(obj)
      .subscribe((result: any) => {
        this.toastr.success("Comment posted successfully");
        this.commentForm.reset();

        // Track the comment ID to prevent socket duplicate
        const commentId = result.data?.id;
        if (commentId) {
          this.recentlyPostedCommentIds.add(commentId);
          // Auto-remove from tracking after delay to allow socket event to be received
          setTimeout(() => {
            this.recentlyPostedCommentIds.delete(commentId);
          }, this.COMMENT_DEDUP_TIMEOUT);
        }

        // Get current user data to enrich the comment
        const currentUserData = this.auth.getUserData();
        const currentUser = typeof currentUserData === 'string' ? JSON.parse(currentUserData) : (currentUserData || {});

        // Build complete comment object with current user's info
        const completeComment = {
          ...result.data,
          user_name: currentUser.user_name || result.data?.user_name || 'User',
          profile_picture: currentUser.profile_picture || currentUser.profile_image || result.data?.profile_picture,
          user_id: currentUser.user_id || result.data?.user_id,
          likes_count: result.data?.likes_count || 0,
          likedByMe: false,
          created_at: result.data?.created_at || new Date().toISOString()
        };

        // Add/Update enriched comment to the list (prevents duplicate if socket fired first)
        const existingIndex = this.commentData.findIndex((c: any) => c.id === completeComment.id);
        if (existingIndex !== -1) {
          this.commentData[existingIndex] = {
            ...this.commentData[existingIndex],
            ...completeComment
          };
        } else {
          this.commentData.unshift(completeComment);
        }
      }, (error: HttpErrorResponse) => {
        this.toastr.error("Something went wrong. please try later")
        // error handler
      })
  }

  getMarketContext(): void {
    if (!this.marketID) return;
    this.isLoadingContext = true;
    this.service.getMarketContext(this.marketID).subscribe({
      next: (res: any) => {
        this.marketContext = res.data;
        this.isLoadingContext = false;
      },
      error: (err: any) => {
        console.error('Error fetching market context:', err);
        this.isLoadingContext = false;
      }
    });
  }

  generateMarketContext(): void {
    if (!this.marketID || !this.marketData?.refresh) return;
    this.isGeneratingContext = true;
    this.service.generateMarketContext(this.marketID).subscribe({
      next: (res: any) => {
        this.marketContext = res.data;
        this.isGeneratingContext = false;
        this.toastr.success('Market context generated successfully');
      },
      error: (err: any) => {
        console.error('Error generating market context:', err);
        this.isGeneratingContext = false;
        this.toastr.error('Failed to generate market context');
      }
    });
  }

  // Scroll-based pagination handlers
  onCommentsScroll(event: any): void {
    const element = event.target;
    const scrollThreshold = 200; // pixels from bottom

    // Calculate if we're near the bottom
    const isNearBottom = element.scrollHeight - (element.scrollTop + element.clientHeight) < scrollThreshold;

    if (isNearBottom && !this.isLoadingComments && this.hasMoreComments) {
      this.getCommentsList(true);
    }
  }

  onActivityScroll(event: any): void {
    const element = event.target;
    const scrollThreshold = 200; // pixels from bottom
    this.hideHolderTooltipImmediately();

    // Calculate if we're near the bottom
    const isNearBottom = element.scrollHeight - (element.scrollTop + element.clientHeight) < scrollThreshold;

    if (isNearBottom && !this.isLoadingActivity && this.hasMoreActivity) {
      this.loadActivity(true);
    }
  }

  onTopHoldersScroll(event: any): void {
    const element = event.target;
    const scrollThreshold = 200; // pixels from bottom
    this.hideHolderTooltipImmediately();

    // Calculate if we're near the bottom
    const isNearBottom = element.scrollHeight - (element.scrollTop + element.clientHeight) < scrollThreshold;

    // For now, loadTopHolders refreshes all, but we check the global loading flag
    if (isNearBottom && !this.isLoadingHolders) {
      // In a fully paginated dynamic version, we'd check hasMore per outcomeGroup
      // but for initial fix we'll just check if any outcomeGroup has more
      const canLoadMore = this.outcomesHolders.some(og => og.hasMore);
      if (canLoadMore) {
        this.loadTopHolders(this.marketID, true);
      }
    }
  }

  onPositionsScroll(event: any): void {
    const element = event.target;
    const scrollThreshold = 200; // pixels from bottom
    this.hideHolderTooltipImmediately();

    // Calculate if we're near the bottom
    const isNearBottom = element.scrollHeight - (element.scrollTop + element.clientHeight) < scrollThreshold;

    if (isNearBottom && !this.isLoadingYesPositions && this.hasMoreYesPositions) {
      this.loadPositions(true);
    }
  }

  ngOnDestroy() {
    if (this.likeSub) this.likeSub.unsubscribe();
    if (this.unlikeSub) this.unlikeSub.unsubscribe();
    if (this.newCommentSub) this.newCommentSub.unsubscribe();
    if (this.priceSub) this.priceSub.unsubscribe();
    if (this.orderBookStreamSub) this.orderBookStreamSub.unsubscribe();
    if (this.bookmarkSubscription) this.bookmarkSubscription.unsubscribe();
    this.socketservice.disconnect();
    // Cleanup code if needed
    if (this.blurTimeout) {
      clearTimeout(this.blurTimeout);
    }
    if (this.amountBlurTimeout) {
      clearTimeout(this.amountBlurTimeout);
    }
    if (this.marketSellBlurTimeout) {
      clearTimeout(this.marketSellBlurTimeout);
    }
    if (this.holderTooltipShowTimeout) {
      clearTimeout(this.holderTooltipShowTimeout);
    }
    if (this.holderTooltipHideTimeout) {
      clearTimeout(this.holderTooltipHideTimeout);
    }
    if (this.portfolioGlobalSubscription) {
      this.portfolioGlobalSubscription.unsubscribe();
    }
    // Clear recently posted comments tracking
    this.recentlyPostedCommentIds.clear();
    // Leaving the page with a popup open must not strand the lock on <body>
    this.closeAllPopups();
  }

  // Local stream removed - now using global stream from AuthService in ngOnInit


  @HostListener('window:scroll')
  @HostListener('window:resize')
  onViewportChange() {
    this.hideHolderTooltipImmediately();
    this.isHoldersMobileView = this.isMobileViewport();

    // The sheet only exists on mobile — growing past the breakpoint restores the side panel
    if (window.innerWidth >= 576) {
      this.closeMobileTradeSheet(false);
      // Desktop shows every outcome column, so the picker has nothing left to pick
      this.showHoldersOutcomeDropdown = false;
    }

    // An open list was measured against where the trigger used to be
    if (this.showMinAmtDropdown) {
      this.updateMinAmtDropdownPlacement();
    }

    if (this.showHoldersOutcomeDropdown) {
      this.updateHoldersOutcomeDropdownPlacement();
    }
  }

  showHolderTooltip(holder: Holder, element: HTMLElement): void {
    if (this.holderTooltipHideTimeout) {
      clearTimeout(this.holderTooltipHideTimeout);
      this.holderTooltipHideTimeout = null;
    }

    if (this.holderTooltipShowTimeout) {
      clearTimeout(this.holderTooltipShowTimeout);
    }

    this.holderTooltipShowTimeout = setTimeout(() => {
      this.hoveredHolder = holder;
      this.updateHolderTooltipPosition(element);
      this.isHolderTooltipVisible = false;
      this.cdRef.detectChanges();

      requestAnimationFrame(() => {
        this.isHolderTooltipVisible = true;
      });
    }, this.HOLDER_TOOLTIP_DELAY);
  }

  hideHolderTooltip(): void {
    if (this.holderTooltipShowTimeout) {
      clearTimeout(this.holderTooltipShowTimeout);
      this.holderTooltipShowTimeout = null;
    }

    if (!this.hoveredHolder) {
      return;
    }

    this.isHolderTooltipVisible = false;

    if (this.holderTooltipHideTimeout) {
      clearTimeout(this.holderTooltipHideTimeout);
    }

    this.holderTooltipHideTimeout = setTimeout(() => {
      this.hoveredHolder = null;
    }, this.HOLDER_TOOLTIP_FADE_DURATION);
  }

  hideHolderTooltipImmediately(): void {
    if (this.holderTooltipShowTimeout) {
      clearTimeout(this.holderTooltipShowTimeout);
      this.holderTooltipShowTimeout = null;
    }

    if (this.holderTooltipHideTimeout) {
      clearTimeout(this.holderTooltipHideTimeout);
      this.holderTooltipHideTimeout = null;
    }

    this.hoveredHolder = null;
    this.isHolderTooltipVisible = false;
  }

  updateHolderTooltipPosition(element: HTMLElement): void {
    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const gap = this.HOLDER_TOOLTIP_GAP;
    const tooltipWidth = this.HOLDER_TOOLTIP_WIDTH;
    const tooltipHeight = this.HOLDER_TOOLTIP_HEIGHT;

    let placement: 'right' | 'top' | 'left' | 'bottom' = 'right';
    let left = rect.right + gap;
    let top = rect.top + (rect.height / 2) - (tooltipHeight / 2);

    if (left + tooltipWidth > viewportWidth - 16) {
      placement = 'top';
      left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
      top = rect.top - tooltipHeight - gap;
    }

    if (placement === 'top' && top < 16) {
      placement = 'left';
      left = rect.left - tooltipWidth - gap;
      top = rect.top + (rect.height / 2) - (tooltipHeight / 2);
    }

    if (placement === 'left' && left < 16) {
      placement = 'bottom';
      left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
      top = rect.bottom + gap;
    }

    this.holderTooltipPlacement = placement;
    this.holderTooltipLeft = Math.min(Math.max(left, 16), viewportWidth - tooltipWidth - 16);
    this.holderTooltipTop = Math.min(Math.max(top, 16), viewportHeight - tooltipHeight - 16);
  }

  getHolderMeta(holder: Holder): string {
    const joinedDate = holder.joined_at || holder.created_at;

    if (joinedDate) {
      const parsedDate = new Date(joinedDate);

      if (!Number.isNaN(parsedDate.getTime())) {
        return `Joined ${parsedDate.toLocaleString('en-US', { month: 'short', year: 'numeric' })}`;
      }
    }

    return 'Trader profile';
  }

  getHolderPositionsValue(holder: Holder): string {
    if (holder.position_value !== undefined && holder.position_value !== null && holder.position_value !== '') {
      return this.formatCompactValue(holder.position_value, true);
    }

    return this.formatCompactValue(holder.shares, false);
  }

  getHolderProfitLossValue(holder: Holder): string {
    if (holder.profit_loss === undefined || holder.profit_loss === null || holder.profit_loss === '') {
      return '--';
    }

    return this.formatCompactValue(holder.profit_loss, true, true);
  }

  getHolderVolumeValue(holder: Holder): string {
    const volume = holder.volume ?? this.marketData?.volume;

    if (volume === undefined || volume === null || volume === '') {
      return '--';
    }

    return this.formatCompactValue(volume, true);
  }

  formatCompactValue(value: number | string, isCurrency: boolean = false, includePositiveSign: boolean = false): string {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
      return '--';
    }

    const formatter = new Intl.NumberFormat('en-US', {
      notation: 'compact',
      maximumFractionDigits: numericValue >= 1000 ? 1 : 2
    });

    const formattedValue = formatter.format(Math.abs(numericValue)).replace(/[KMBT]/g, (match) => match.toLowerCase());
    const prefix = isCurrency ? '$' : '';
    const sign = numericValue < 0 ? '-' : includePositiveSign && numericValue > 0 ? '+' : '';

    return `${sign}${prefix}${formattedValue}`;
  }

  // Trading methods
  setAction(action: string) {
    this.selectedAction = action;
    this.tradeButtonClicked = false; // Reset when action changes
    this.showSellTooltip = false; // Close sell tooltip if open
    this.showProfitTooltip = false; // Close profit tooltip if open
    this.showAvgPriceTooltip = false; // Close avg price tooltip if open

    // Calculate updated totals for the new action
    this.calculateTotal();
    this.calculateToWin();
    this.cdRef.detectChanges();
  }

  // Helper to determine if the first outcome (e.g., 'Yes' in binary markets) is currently selected
  isFirstOutcomeSelected(): boolean {
    if (!this.selectedOutcome || !this.marketData?.outcomes?.length) return true;
    return this.selectedOutcome.id === this.marketData.outcomes[0].id;
  }

  setOption(option: string) {
    this.selectedOption = option.toLowerCase();
    this.tradeButtonClicked = false;

    // 2. Find the outcome object from your market data
    if (this.marketData?.outcomes?.length) {
      const outcomeIndex = this.marketData.outcomes.findIndex(
        (o: any) => o.title.toLowerCase() === option.toLowerCase()
      );

      if (outcomeIndex !== -1) {
        const outcome = this.marketData.outcomes[outcomeIndex];
        if (outcome) {
          // Store the full outcome object
          this.selectedOutcome = outcome;
          this.selectedOutcomeId = outcome.id;

          // 1. Update the price shown in the input field based on the selected outcome
          // Fallback to lastPriceYes/No if outcome.price is not immediately available
          let price = Number(outcome.price || 0);
          if (price === 0) {
            price = (outcomeIndex === 0) ? this.lastPriceYes : (outcomeIndex === 1 ? this.lastPriceNo : 0);
          }
          
          this.limitPrice = price <= 1 ? Math.round(price * 100) : price;
          if (this.limitPrice === 0) this.limitPrice = 50; // Default fallback to 50 if still 0

          // 3. TRIGGER THE API CALL
          if (this.selectedOutcomeId) {
            this.loadOrderBook(this.selectedOutcomeId);
          }

          // Open the correct row in your UI. Multi-outcome rows stay collapsed —
          // they only expand/collapse on a tap of the outcome card itself.
          if (!this.isMultiOutcomeFlag()) {
            this.openRow(outcomeIndex, option.toLowerCase());
          }
        }
      }
    }

    // 4. Recalculate totals for the order slip
    this.calculateTotal();
    this.calculateToWin();
  }

  selectLimitType(limitType: string) {
    this.selectedLimitType = limitType;
    this.showLimitDropdown = false;
    this.tradeButtonClicked = false;
    if (limitType === 'Market') {
      this.shares = 0;
      this.limitPrice =
        this.isFirstOutcomeSelected()
          ? this.lastPriceYes
          : this.lastPriceNo;
    }
  }

  limitDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.showLimitDropdown = !this.showLimitDropdown;
    this.closeOtherDropdowns('limit');
    if (this.showLimitDropdown) {
      this.placePopup('limitType', event);
    }
  }

  // Market Buy methods
  updateAmount(value: number) {
    this.amount = value;
    if (this.amount < 0) this.amount = 0;
    this.calculateToWin();
  }

  onAmountFocus() {
    this.isAmountFocused = true;
  }

  onAmountBlur() {
    // Delay hiding the quick amount buttons
    this.amountBlurTimeout = setTimeout(() => {
      this.isAmountFocused = false;
    }, 200);
  }

  incrementAmount(increment: number, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();

      // Clear blur timeout to keep quick amount buttons visible
      if (this.amountBlurTimeout) {
        clearTimeout(this.amountBlurTimeout);
      }
    }

    this.amount = (this.amount || 0) + increment;
    if (this.amount < 0) this.amount = 0;
    this.calculateToWin();

    // Keep focus state
    this.isAmountFocused = true;
  }

  setMaxAmount(event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();

      // Clear blur timeout to keep quick amount buttons visible
      if (this.amountBlurTimeout) {
        clearTimeout(this.amountBlurTimeout);
      }
    }

    // For now, setting to 1000 as example. You might want to get this from user's balance
    this.amount = 1000;
    this.calculateToWin();

    // Keep focus state
    this.isAmountFocused = true;
  }

  // Calculate potential win for Market Buy - FIXED: Now returns number
  calculateToWin(): number {

    let calculatedToWin = 0;

    // MARKET BUY
    if (
      this.selectedLimitType === 'Market' &&
      this.selectedAction === 'Buy' &&
      this.selectedOption
    ) {

      if (this.amount > 0) {

        const shares = this.getCalculatedShares();

        // payout = $1 per share if outcome wins
        calculatedToWin = shares;
      }
    }

    // MARKET SELL
    else if (
      this.selectedLimitType === 'Market' &&
      this.selectedAction === 'Sell' &&
      this.selectedOption
    ) {
      if (this.marketSellShares > 0) {
        calculatedToWin = this.calculateMarketSellReceiveAmount();
      }
    }

    // LIMIT BUY
    else if (this.selectedLimitType === 'Limit' && this.selectedAction === 'Buy') {
      calculatedToWin = this.shares; // potential payout is 1:1 in USD per share
    }

    // LIMIT SELL
    else if (this.selectedLimitType === 'Limit' && this.selectedAction === 'Sell') {
      calculatedToWin = this.calculateReceiveAmount();
    }

    this.toWin = parseFloat(calculatedToWin.toFixed(4));

    this.calculateProfitDetails();

    return this.toWin;
  }

  // Calculate average price for Market Buy
  getAvgPrice(): number {
    // If user has existing position, show their avg buy price
    if (this.userData?.avg_buy_price) {
      return parseFloat(this.userData.avg_buy_price);
    }

    // For Market orders - use current market price
    if (this.selectedLimitType === 'Market') {
      return this.isFirstOutcomeSelected() ? this.lastPriceYes : this.lastPriceNo;
    }

    // For Limit orders - use limit price the user set
    if (this.selectedLimitType === 'Limit' && this.limitPrice > 0) {
      return this.limitPrice;
    }

    // Fallback
    return this.isFirstOutcomeSelected() ? this.lastPriceYes : this.lastPriceNo;
  }

  // Calculate shares for display in Market Buy
  getCalculatedShares(): number {

    if (!this.amount || !this.selectedOption) return 0;

    const priceInCents =
      this.isFirstOutcomeSelected()
        ? this.lastPriceYes
        : this.lastPriceNo;

    if (priceInCents <= 0) return 0;

    const price = priceInCents / 100;

    const rawShares = this.amount / price;

    return Math.floor(rawShares);
  }
  // Limit Order methods
  // Limit Order methods
  // Limit Order methods
  updateLimitPrice(event: any) {
    const input = event.target;
    let val = input.value;

    if (val === null || val === undefined || val === '') {
      this.limitPrice = 0;
      return;
    }

    let strVal = val.toString().trim();

    // 1. Auto-format 3+ digit integers: 111 -> 11.1
    // Only happens if there's no decimal yet and the value is 100 or more
    if (!strVal.includes('.') && parseFloat(strVal) >= 100) {
      const num = parseFloat(strVal);
      strVal = (num / 10).toFixed(1);
    }

    // 2. Enforce 1 decimal place (TRUNCATE)
    if (strVal.includes('.')) {
      const parts = strVal.split('.');
      if (parts[1].length > 1) {
        strVal = parts[0] + '.' + parts[1].substring(0, 1);
      }
    }

    let currentVal = parseFloat(strVal);

    // 2. Enforce <= 99 limit
    if (currentVal > 99) {
      this.toastr.error('Price should not exceed 99');
      currentVal = 99;
      strVal = "99";
    }

    // Force the DOM value to match our cleaned string/value
    input.value = strVal;

    // Update the model and recalculate
    this.limitPrice = currentVal;
    this.calculateTotal();
    this.calculateToWin();
  }

  updateShares(value: any) {
    const numValue = parseFloat(value);
    console.log("shares", numValue);
    if (isNaN(numValue)) {
      this.shares = 0;
    } else {
      this.shares = Math.floor(numValue);
    }

    // Optional: Sync UI if value was truncated
    if (value !== null && value !== undefined && value !== '' && parseFloat(value) !== this.shares) {
      this.investForm.get('shares')?.setValue(this.shares, { emitEvent: false });
    }

    this.calculateTotal();
    this.calculateToWin();
  }

  setSharesFromMatching(value: number) {
    this.investForm.get('shares')?.setValue(value);
    this.calculateTotal();
    this.calculateToWin();
  }

  calculateTotal() {
    // Only calculate total for Limit orders
    if (this.selectedLimitType === 'Limit') {
      this.total = (this.shares * this.limitPrice) / 100;
      this.calculateProfitDetails();
    }
  }

  calculateMatchingShares(): number {
    const userPrice = this.limitPrice; // in cents
    const userShares = this.shares;

    if (!userPrice || !userShares) return 0;

    let totalMatch = 0;

    if (this.selectedAction === 'Buy') {
      // Find sellers (asks) whose price is <= our limit price
      // Should match starting from lowest price
      const sortedAsks = [...this.asks].sort((a, b) => a.price - b.price);
      for (const ask of sortedAsks) {
        if (ask.price <= userPrice) {
          totalMatch += ask.shares;
          if (totalMatch >= userShares) return userShares;
        }
      }
    } else if (this.selectedAction === 'Sell') {
      // Find buyers (bids) whose price is >= our limit price
      // Should match starting from highest price
      const sortedBids = [...this.bids].sort((a, b) => b.price - a.price);
      for (const bid of sortedBids) {
        if (bid.price >= userPrice) {
          totalMatch += bid.shares;
          if (totalMatch >= userShares) return userShares;
        }
      }
    }

    return parseFloat(totalMatch.toFixed(2));
  }

  calculateReceiveAmount(): number {
    if (this.selectedAction === 'Sell' && this.shares > 0 && this.limitPrice > 0) {
      // For Sell, you receive: shares * price
      return (this.shares * this.limitPrice) / 100;
    }
    return 0;
  }

  setSellPercentage(percentage: number, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();

      // Clear blur timeout to keep matching section visible
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
      }
    }

    if (this.selectedAction === 'Sell') {
      const maxShares = this.maxAvailableShares; // Get from your data
      const calculatedShares = Math.floor((maxShares * percentage) / 100);
      this.investForm.get('shares')?.setValue(calculatedShares);
      this.calculateTotal();
      this.calculateToWin();

      // Keep focus state
      this.isSharesFocused = true;
    }
  }

  calculateAmericanOdds(): number {
    if (this.isFirstOutcomeSelected()) {
      // For Yes: (100 - price) * 100 / price
      return ((100 - this.limitPrice) * 100) / this.limitPrice;
    } else {
      // For No: (price * 100) / (100 - price)
      return (this.limitPrice * 100) / (100 - this.limitPrice);
    }
  }

  calculateDecimalOdds(): number {
    if (this.isFirstOutcomeSelected()) {
      // For Yes: 100 / price
      return 100 / this.limitPrice;
    } else {
      // For No: 100 / (100 - price)
      return 100 / (100 - this.limitPrice);
    }
  }

  toggleSellTooltip(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.showSellTooltip = !this.showSellTooltip;

    // Close other tooltips
    if (this.showSellTooltip) {
      this.showProfitTooltip = false;
      this.showAvgPriceTooltip = false;
    }
  }

  calculateProfitDetails() {
    // For Market Buy
    if (this.selectedLimitType === 'Market' && this.selectedAction === 'Buy' && this.selectedOption) {
      if (this.amount > 0) {
        // Calculate profit (amount invested returns)
        this.profit = this.toWin;

        // Calculate change percentage using live streaming price
        const currentPrice = this.isFirstOutcomeSelected() ? this.lastPriceYes : this.lastPriceNo;
        this.changePercentage = ((100 - currentPrice) / currentPrice) * 100;

        // Calculate multiplier
        this.multiplier = 100 / currentPrice;
      } else {
        this.profit = 0;
        this.changePercentage = 0;
        this.multiplier = 0;
      }
    }
    // For Limit orders
    else if (this.shares > 0 && this.limitPrice > 0) {
      // Calculate profit (simplified - adjust based on your business logic)
      this.profit = this.toWin;

      // Calculate change percentage (simplified example)
      this.changePercentage = this.limitPrice > 0 ?
        ((100 - this.limitPrice) / this.limitPrice) * 100 : 0;

      // Calculate multiplier (simplified example)
      this.multiplier = this.limitPrice > 0 ? 100 / this.limitPrice : 0;
    } else {
      this.profit = 0;
      this.changePercentage = 0;
      this.multiplier = 0;
    }
  }

  // Toggle tooltip visibility
  toggleProfitTooltip(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.showProfitTooltip = !this.showProfitTooltip;

    // Close other tooltips
    if (this.showProfitTooltip) {
      this.showSellTooltip = false;
      this.showAvgPriceTooltip = false;
    }
  }

  async onTradeButtonClick() {
    console.log("========== TRADE BUTTON CLICKED ==========");

    if (this.tradeButtonClicked) return;

    // 1. Basic Validations
    if (!this.auth.isLoggedIn()) {
      this.auth.sendOperationSignal("login");
      return;
    }

    if (!this.auth.isTradeEnabled()) {
      this.enableTradingModalOpen = true;
      return;
    }

    const state = this.marketData?.resolution_state as ResolutionState;
    if ([ResolutionState.MARKET_EXPIRED, ResolutionState.WINNER_DECLARED, ResolutionState.SCHEDULED].includes(state)) {
      this.toastr.error('Trading not allowed for this market');
      return;
    }

    if (!this.selectedAction || !this.selectedOption) {
      this.toastr.error('Select action and option');
      return;
    }

    // 4. Calculate Share Count
    let shareCount = 0;
    if (this.selectedLimitType === 'Market') {
      shareCount = this.selectedAction === 'Buy' ? this.getCalculatedShares() : this.marketSellShares;
    } else {
      shareCount = this.shares;
    }

    // 4.5. Limit Price Validation
    if (this.selectedLimitType === 'Limit') {
      if (this.limitPrice <= 0 || this.limitPrice > 99) {
        this.toastr.error('Limit price must be between 0 and 99 cents');
        return;
      }
    }

    if (!shareCount || shareCount <= 0) {
      this.toastr.error('Please enter shares');
      return;
    }

    try {
      this.tradeButtonClicked = true;
      this.cdRef.detectChanges();

      // 2. Wallet & Chain Data
      const account = this.walletService.getAccount();
      const userData = this.auth.getUserData();
      let userAddress;
      let chainId;

      if (userData?.user_type?.toUpperCase() === 'WEB2') {
        userAddress = userData?.public_address;
        chainId = 80002;
      } else {
        userAddress = account?.address;
        chainId = account?.chainId;
      }

      if (!userAddress || !chainId) {
        this.toastr.error('Wallet not connected');
        this.tradeButtonClicked = false;
        this.cdRef.detectChanges();
        return;
      }

      const nonce = await this.web3service.getUserNonce(userAddress);

      // 3. Outcome & Token Data
      const selectedOutcome = this.marketData.outcomes.find(
        (o: any) => o.id === this.selectedOutcome?.id
      );

      if (!selectedOutcome) {
        this.toastr.error('Selected outcome not found');
        this.tradeButtonClicked = false;
        this.cdRef.detectChanges();
        return;
      }
      const tokenId = selectedOutcome.token_id;

      // 5. PRICE LOGIC (The Fix)
      // For the UI/Internal state: this.limitPrice is in CENTS (e.g., 50)
      // For the API: priceInDollars must be DOLLARS (e.g., 0.5)
      // For the Contract: limitPriceInCents must be CENTS (e.g., 50)

      const limitPriceInCents = this.selectedLimitType === 'Market'
        ? (this.isFirstOutcomeSelected() ? this.lastPriceYes : this.lastPriceNo)
        : Math.round(this.limitPrice);

      const priceInDollars = limitPriceInCents / 100;

      const makerAddress = userData?.proxy_wallet || userAddress;

      // 6. Build orderData (Using the calculated Cents)
      const orderData = {
        salt: Math.floor(Date.now() / 1000),
        maker: makerAddress,
        signer: userAddress,
        taker: "0x0000000000000000000000000000000000000000",
        tokenId: tokenId.toString(),
        makerAmount: parseUnits(
          this.selectedAction === 'Buy'
            ? (priceInDollars * shareCount).toString() // Buy: Total cost in cents
            : shareCount.toString(),                      // Sell: Number of shares
          6
        ).toString(),
        takerAmount: parseUnits(
          this.selectedAction === 'Buy'
            ? shareCount.toString()                       // Buy: Number of shares
            : (priceInDollars * shareCount).toString(),// Sell: Total receive in cents
          6
        ).toString(),
        expiration: this.calculateExpiration(this.selectExpirationType), nonce: Number(nonce),
        feeRateBps: 0,
        side: this.selectedAction === 'Buy' ? OrderSide.BUY : OrderSide.SELL,
        signatureType: 1
      };

      console.log('--- Trade Execution Debug ---');
      console.log('Maker Address:', makerAddress);
      console.log('Signer Address (Expected):', userAddress);
      console.log('Chain ID:', chainId);
      console.log('Verifying Contract:', environment.CTF_EXCHANGE_ADDRESS);
      console.log('Order Data:', orderData);

      // 7. Sign the Order
      const structured_data = {
        types: {
          EIP712Domain: [
            { name: "name", type: "string" },
            { name: "version", type: "string" },
            { name: "chainId", type: "uint256" },
            { name: "verifyingContract", type: "address" }
          ],
          Order: [
            { name: "salt", type: "uint256" },
            { name: "maker", type: "address" },
            { name: "signer", type: "address" },
            { name: "taker", type: "address" },
            { name: "tokenId", type: "uint256" },
            { name: "makerAmount", type: "uint256" },
            { name: "takerAmount", type: "uint256" },
            { name: "expiration", type: "uint256" },
            { name: "nonce", type: "uint256" },
            { name: "feeRateBps", type: "uint256" },
            { name: "side", type: "uint8" },
            { name: "signatureType", type: "uint8" }
          ]
        },
        primaryType: "Order",
        domain: {
          name: "Polymarket CTF Exchange",
          version: "1",
          chainId: Number(chainId),
          verifyingContract: environment.CTF_EXCHANGE_ADDRESS
        },
        message: orderData
      };
      console.log('Structured Data for Signing:', structured_data);

      let signature;
      if (userData?.user_type === 'WEB2') {
        signature = await this.web2Service.signTypedData(userAddress, structured_data);
      } else {
        signature = await this.walletService.signTypedData(structured_data);
      }
      if (!signature) {
        this.toastr.error('Failed to sign order');
        this.tradeButtonClicked = false;
        this.cdRef.detectChanges();
        return;
      }
      const hexSignature = signature.slice(2);

      // 8. Construct Final Payload for API
      const orderPayload = {
        outcome_id: this.selectedOutcome?.id,
        side: this.selectedAction.toUpperCase(),
        order_type: this.selectedLimitType.toUpperCase(),
        shares: Number(shareCount),
        price: priceInDollars, // Sent as Dollars (e.g. 0.5)
        order_data: orderData,
        signature: hexSignature
      };

      // console.log("Final payload to backend:", orderPayload);

      const response = await firstValueFrom(
        this.service.placeOrder(orderPayload, this.marketID, this.auth.getUserData()?.id)
      );

      this.toastr.success('Order placed successfully');
      if (this.selectedOutcomeId) {
        this.hasCentered = false; // Reset centering flag for new order book data
        this.loadOrderBook(this.selectedOutcomeId);
      }
      this.resetForm();

    } catch (err: any) {
      console.error("Error placing order:", err);
      if (err instanceof HttpErrorResponse) {
        const errorCode = err.error?.detail?.error_code;
        const message = ERROR_MESSAGES[errorCode] || 'Failed to place order';
        this.toastr.error(message);
      } else {
        this.toastr.error('Failed to place order');
      }
    } finally {
      this.tradeButtonClicked = false;
      this.cdRef.detectChanges();
    }
  }

  // Optional: Reset form after order placement
  resetForm() {
    this.investForm.get('shares')?.setValue(null, { emitEvent: false });
    this.investForm.get('marketSellShares')?.setValue(null, { emitEvent: false });
    this.shares = 0;
    this.limitPrice =
      this.isFirstOutcomeSelected()
        ? (this.lastPriceYes || 50)
        : (this.lastPriceNo || 50);
    this.total = 0;
    this.toWin = 0;
    this.amount = 0;
    this.marketSellShares = 0;
    this.selectExpirationType = "";
    this.calculateTotal();
    this.calculateToWin();
    this.cdRef.detectChanges();
  }


  getTradeButtonText(): SafeHtml | string {
    if (!this.selectedAction || !this.selectedOption) {
      return 'Trade';
    }

    if (this.tradeButtonClicked) {
      // Special case for Market Buy
      if ((this.selectedLimitType === 'Market' || this.selectedLimitType === 'Limit') && this.selectedAction === 'Buy') {
        return 'Processing...';
      }

      // Special case for Market Sell
      if ((this.selectedLimitType === 'Market' || this.selectedLimitType === 'Limit') && this.selectedAction === 'Sell') {
        return 'Processing...';
      }

      // For Limit orders
      const html = `
      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg> Processing...
      `;
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    // Default texts when not loading
    if (this.selectedAction === 'Buy' && this.amount > (this.availableCashBalance || 0)) {
      return 'Deposit';
    }

    return `Trade`;
  }

  // Disabled while signed out; enabled again as soon as the user is logged in
  // and an action / outcome is selected.
  isTradeButtonDisabled(): boolean {
    if (!this.auth.isLoggedIn()) {
      return true;
    }

    return !this.selectedAction || !this.selectedOption;
  }

  // Signed out the disabled state is styling only. The native disabled attribute
  // swallows the click, and that click is what opens the login modal
  // (onTradeButtonClick), so the login prompt has to keep receiving it.
  isTradeButtonBlocked(): boolean {
    return this.auth.isLoggedIn() && this.isTradeButtonDisabled();
  }

  // Get button class based on state
  getTradeButtonClass(): string {

    if (this.isMarketClosed()) {
      return 'font-syne text-sm text-gray-400 bg-gray-100 border border-gray-300 font-semibold rounded-lg cursor-not-allowed px-4 py-3 opacity-70';
    }

    if (this.isTradeButtonDisabled()) {
      return 'font-syne text-sm text-gray-400 bg-gray-200 font-semibold border border-transparent rounded-lg cursor-not-allowed px-4 py-3';
    }

    // Special case for Market Buy
    if (this.selectedLimitType === 'Market' && this.selectedAction === 'Buy') {
      let baseClass = 'font-syne text-sm text-white font-semibold border border-transparent rounded-lg cursor-pointer px-4 py-3 duration-300 ease-in-out bg-black hover:bg-transparent hover:text-black hover:border-black';

      if (this.amount <= 0) {
        return 'font-syne text-sm text-gray-400 bg-gray-200 font-semibold border border-transparent rounded-lg cursor-not-allowed px-4 py-3';
      }

      if (this.tradeButtonClicked) {
        return baseClass + ' opacity-50 cursor-not-allowed pointer-events-none';
      }

      return baseClass;
    }

    // Special case for Market Sell
    if (this.selectedLimitType === 'Market' && this.selectedAction === 'Sell') {
      let baseClass = 'font-syne text-sm text-white font-semibold border border-transparent rounded-lg cursor-pointer px-4 py-3 duration-300 ease-in-out bg-black hover:bg-white hover:text-black hover:border-black';

      if (this.marketSellShares <= 0) {
        return 'font-syne text-sm text-gray-400 bg-gray-200 font-semibold border border-transparent rounded-lg cursor-not-allowed px-4 py-3';
      }

      if (this.tradeButtonClicked) {
        return baseClass + ' opacity-50 cursor-not-allowed pointer-events-none';
      }

      return baseClass;
    }

    // Default for Limit orders
    let finalClass = 'font-syne text-sm text-white font-semibold border border-transparent rounded-lg cursor-pointer px-4 py-3 duration-300 ease-in-out bg-black hover:bg-white hover:text-black hover:border-black';

    if (this.tradeButtonClicked) {

      finalClass += ' opacity-50 cursor-not-allowed pointer-events-none';
    }

    return finalClass;
  }


  // Reset trade button state (call this when you want to reset)
  resetTradeButton() {
    this.tradeButtonClicked = false;
  }

  // Shares input focus/hover handlers
  onSharesFocus() {
    this.isSharesFocused = true;
  }

  onSharesBlur() {
    // Delay hiding the matching section to allow button clicks
    this.blurTimeout = setTimeout(() => {
      this.isSharesFocused = false;
    }, 200);
  }

  // Check if matching increments should be shown
  showMatchingIncrements(): boolean {
    return this.isSharesFocused;
  }

  // Check if total/to win should be shown for Limit orders
  showTotalToWin(): boolean {
    if (this.selectedLimitType === 'Limit') {
      return this.shares > 0;
    }
    return false;
  }

  // Check if To Win and Avg. Price should be shown for Market Buy
  showMarketBuyDetails(): boolean {
    return this.selectedLimitType === 'Market' &&
      this.selectedAction === 'Buy' &&
      this.amount > 0;
  }

  // Existing methods...
  setActiveTab(tab: MarketTab) {
    this.activeTab = tab;
    // console.log("Tab clicked:", tab); // Check what 'tab' actually is
    if (tab === MarketTab.HOLDERS) {
      this.loadTopHolders(this.marketID);
    } else if (tab === MarketTab.POSITION) {
      this.loadPositions();
    } else if (tab === MarketTab.ACTIVITY) {
      this.loadActivity();
    } else if (tab === MarketTab.COMMENTS) {
      this.getCommentsList();
    }
    else if (tab === MarketTab.ORDERBOOK) {
      this.loadOrderBook();
    }
  }

  openDropdown() {
    this.dropdownOpen = true;
  }

  toggleDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.dropdownOpen = !this.dropdownOpen;
    if (this.dropdownOpen) {
      this.placePopup('commentsFilter', event);
    }
  }

  dateDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.showDateDropdown = !this.showDateDropdown;
    this.closeOtherDropdowns('date');
  }

  allDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.showAllDropdown = !this.showAllDropdown;
    this.closeOtherDropdowns('all');
  }

  minAmtDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.showMinAmtDropdown = !this.showMinAmtDropdown;
    this.closeOtherDropdowns('minAmt');
  }

  private closeOtherDropdowns(current: string) {
    if (current !== 'dropdown') this.dropdownOpen = false;
    if (current !== 'date') this.showDateDropdown = false;
    if (current !== 'all') this.showAllDropdown = false;
    if (current !== 'minAmt') this.showMinAmtDropdown = false;
    if (current !== 'limit') this.showLimitDropdown = false;
  }

  selectFilter(value: string) {
    this.selectedFilter = value;
    this.dropdownOpen = false;
  }

  toggleBookmark(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    // Use marketData.id if available (UUID), fallback to marketID (slug)
    const idToBookmark = this.marketData?.id || this.marketID;
    this.bookmarkService.toggleBookmark(idToBookmark);
  }

  showAvgPriceTooltip: boolean = false;

  // Add this method to toggle Avg. Price tooltip
  toggleAvgPriceTooltip(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.showAvgPriceTooltip = !this.showAvgPriceTooltip;

    // Close other tooltips
    if (this.showAvgPriceTooltip) {
      this.showProfitTooltip = false;
      this.showSellTooltip = false;
    }
  }

  // Add this method to calculate market impact (example)
  calculateMarketImpact(): number {
    // Example calculation - you should adjust this based on your actual logic
    if (this.amount > 0 && this.selectedOption) {
      // Simple percentage calculation
      const basePrice = this.isFirstOutcomeSelected() ? this.lastPriceYes : this.lastPriceNo;
      return (this.amount / 1000) * 0.5; // Example: 0.5% impact per $1000
    }
    return 0;
  }

  // Add this method to get estimated fill
  getEstimatedFill(): number {
    // Example calculation - you should adjust this based on your actual logic
    if (this.amount > 0 && this.selectedOption) {
      const currentPrice = this.isFirstOutcomeSelected() ? this.lastPriceYes / 100 : this.lastPriceNo / 100;
      return this.amount / currentPrice;
    }
    return 0;
  }


  @HostListener('document:click', ['$event'])
  closeAllDropdowns(event: Event) {
    const target = event.target as HTMLElement;

    // Close date dropdown if clicking outside
    const isDateDropdown = target.closest('.date-dropdown-container') !== null;
    if (!isDateDropdown) {
      this.showDateDropdown = false;
    }

    const isAllDropdown = target.closest('.all-dropdown') !== null;
    if (!isAllDropdown) {
      this.showAllDropdown = false;
    }



    const isToggleDropDown = target.closest('.review-filter') !== null;
    if (!isToggleDropDown) {
      this.dropdownOpen = false;
    }

    // Close "Min Amount" dropdown if clicking outside
    const isMinAmtDropdown = target.closest('.min-amt-dropdown') !== null;
    if (!isMinAmtDropdown) {
      this.showMinAmtDropdown = false;
    }

    // Close the Top Holders outcome picker if clicking outside
    const isHoldersOutcomeDropdown = target.closest('.holders-outcome-dropdown') !== null;
    if (!isHoldersOutcomeDropdown) {
      this.showHoldersOutcomeDropdown = false;
    }


    // Close the positions filters if clicking outside. The page is held still
    // while one of these is open, so a click anywhere else has to release it -
    // a menu left open would read as a page that has stopped scrolling.
    const isStatusDropdown = target.closest('.status-filter-dropdown') !== null;
    if (!isStatusDropdown) {
      this.showStatusFilterDropdown = false;
    }

    const isSortDropdown = target.closest('.sort-filter-dropdown') !== null;
    if (!isSortDropdown) {
      this.showSortFilterDropdown = false;
    }

    const isExpirationDropdown = target.closest('.expiration-dropdown') !== null;
    if (!isExpirationDropdown) {
      this.showExpirationDropdown = false;
    }

    // Close limit dropdown
    const isLimitDropdown = target.closest('.limit-type-dropdown') !== null;
    if (!isLimitDropdown) {
      this.showLimitDropdown = false;
    }

    // Close sell tooltip if clicking outside
    const isSellTooltip = target.closest('.sell-tooltip') !== null;
    const isSellTooltipIcon = target.closest('.sell-tooltip-icon') !== null;

    if (!isSellTooltip && !isSellTooltipIcon) {
      this.showSellTooltip = false;
    }

    // Close profit tooltip if clicking outside
    const isProfitTooltip = target.closest('.profit-tooltip') !== null;
    const isProfitTooltipIcon = target.closest('.profit-tooltip-icon') !== null;

    if (!isProfitTooltip && !isProfitTooltipIcon) {
      this.showProfitTooltip = false;
    }

    // Close avg price tooltip if clicking outside
    const isAvgPriceTooltip = target.closest('.avg-price-tooltip') !== null;
    const isAvgPriceTooltipIcon = target.closest('.avg-price-tooltip-icon') !== null;

    if (!isAvgPriceTooltip && !isAvgPriceTooltipIcon) {
      this.showAvgPriceTooltip = false;
    }
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  toggleLike(comment: any) {
    if (!comment?.id) return;

    const payload = {
      event: 'LIKE_ACTION',
      comment_id: comment.id
    };

    // console.log('Sending LIKE_ACTION:', payload);
    this.socketservice.emitRaw(payload);
  }


  toggleAccordion() {
    this.isOpen = !this.isOpen;
  }


  orderBookList = [
    { price: 92, shares: 50, total: 46 },
    { price: 90, shares: 30, total: 27 },
    { price: 88, shares: 40, total: 10 },
  ];

  totalAskValue = this.orderBookList.reduce((acc, item) => acc + item.total, 0);

  toggleOrderBook(index: number) {
    this.selectedIndex = this.selectedIndex === index ? null : index;
  }

  toggleOrderBookState() {
    console.log("Toggling order book: ", this.hasCentered);
    this.hasCentered = false; // Reset centering flag when toggling order book
    if (!this.hasCentered) {
      setTimeout(() => {
        this.recenterOrderBook(); // 👈 IMPORTANT
        this.hasCentered = true; // ✅ mark as done
      }, 100);
    }
    this.isOrderBookOpen = !this.isOrderBookOpen;
  }

  // Trade Yes / Trade No tabs above the order book: switch the outcome the
  // order book is showing, and make sure the (collapsed by default) book is open.
  selectOrderBookTab(title: string) {
    this.setOption(title);
    if (!this.isOrderBookOpen) {
      this.toggleOrderBookState();
    }
  }

  setOrderActiveTab(index: number, tab: string) {
    this.selectedIndex = index;
    this.activeTabs[index] = tab;
    if (tab === 'order') {
      this.loadOrderBook(); // pass marketId if needed
    }
  }

  isTabActive(index: number, tab: string): boolean {
    return this.activeTabs[index] === tab;
  }


  /**
   * Close the enable trading modal.
   */
  closeEnableTradingModal() {
    this.enableTradingModalOpen = false;
  }

  openRow(index: number, side: string) {
    this.selectedIndex = index;
    this.activeSide = side;
    this.activeTabs[index] = 'order';
    this.hasCentered = false; // Set hasCentered to false when toggling an order book row
  }

  // Collapse the expanded multi-outcome row's order book
  closeRow() {
    this.selectedIndex = null;
    this.activeSide = null;
    this.hasCentered = false;
  }

  // Multi-outcome row prices, in cents. Yes is the outcome's own price
  // (the API sends either a 0-1 fraction or already-in-cents), No is its complement.
  getRowYesPrice(row: any): number {
    const price = Number(row?.price);
    if (isNaN(price)) return 50;
    return price <= 1 ? price * 100 : price;
  }

  getRowNoPrice(row: any): number {
    return 100 - this.getRowYesPrice(row);
  }

  // Chance shown on a multi-outcome row, falling back to the market-level probability.
  // Chart legend (multi-outcome mobile): the leading outcomes, one colour each
  legendColors = ['#1CAE91', '#DBA900', '#E5484D'];

  getChartLegendOutcomes(): any[] {
    const outcomes = this.marketData?.outcomes || [];
    return [...outcomes]
      .sort((a: any, b: any) => this.getRowChance(b) - this.getRowChance(a))
      .slice(0, this.legendColors.length);
  }

  trackByOutcomeId(index: number, outcome: any): any {
    return outcome?.id ?? index;
  }

  getRowChance(row: any): number {
    if (row?.win_probability !== undefined && row?.win_probability !== null) {
      return Number(row.win_probability);
    }
    return Number(this.marketData?.win_probability) || 0;
  }

  toggleRow(index: number, data: any) {
    this.selectedOutcome = data;
    this.selectedOutcomeId = data?.id; // Store current ID

    // Set selectedOption based on the toggled outcome title
    this.selectedOption = data?.title?.toLowerCase() || 'yes';

    if (this.selectedIndex === index) {
      this.selectedIndex = null;
      this.activeSide = null;
    } else {
      this.selectedIndex = index;
      this.activeSide = null;
      this.activeTabs[index] = 'order';
      this.hasCentered = false; // Set hasCentered to false when toggling an order book row

      // Load order book for the toggled outcome
      if (this.selectedOutcomeId) {
        this.loadOrderBook(this.selectedOutcomeId);
      }
    }

    // Recalculate totals for the order slip if needed
    this.calculateTotal();
    this.calculateToWin();
  }

  // Add this method to your component class
  handleMatchingIncrementClick(event: Event, increment: number) {
    event.stopPropagation(); // Prevent the click from bubbling up
    event.preventDefault(); // Prevent default behavior
    this.setSharesFromMatching(increment);
    this.isSharesFocused = true; // Keep focus state
  }

  // Also update the incrementShares method to stop propagation
  incrementShares(amount: number, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();

      // Clear blur timeout to keep matching section visible
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
      }
    }

    const currentShares = this.investForm.get('shares')?.value || 0;
    const newShares = Math.max(0, currentShares + amount);
    this.investForm.get('shares')?.setValue(newShares);
    this.calculateTotal();
    this.calculateToWin();

    // Keep focus state
    this.isSharesFocused = true;
  }

  // Add these properties to your component class
  marketSellShares: number = 0;
  isMarketSellSharesFocused: boolean = false;
  private marketSellBlurTimeout: any;

  // Market Sell methods
  updateMarketSellShares(value: any) {
    const numValue = parseFloat(value);
    if (isNaN(numValue)) {
      this.marketSellShares = 0;
    } else {
      this.marketSellShares = Math.floor(numValue);
    }

    // Optional: Sync UI if value was truncated
    if (value !== null && value !== undefined && value !== '' && parseFloat(value) !== this.marketSellShares) {
      this.investForm.get('marketSellShares')?.setValue(this.marketSellShares, { emitEvent: false });
    }

    this.calculateToWin();
  }

  onMarketSellSharesFocus() {
    this.isMarketSellSharesFocused = true;
  }

  onMarketSellSharesBlur() {
    // Delay hiding the percentage buttons
    this.marketSellBlurTimeout = setTimeout(() => {
      this.isMarketSellSharesFocused = false;
    }, 200);
  }

  setMarketSellPercentage(percentage: number, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();

      // Clear blur timeout to keep percentage buttons visible
      if (this.marketSellBlurTimeout) {
        clearTimeout(this.marketSellBlurTimeout);
      }
    }

    // Calculate percentage of max available shares
    const maxShares = this.maxAvailableShares;
    const calculatedShares = Math.floor((maxShares * percentage) / 100);
    this.investForm.get('marketSellShares')?.setValue(calculatedShares);
    this.calculateToWin();

    // Keep focus state
    this.isMarketSellSharesFocused = true;
  }

  // Calculate receive amount for Market Sell
  calculateMarketSellReceiveAmount(): number {
    if (this.marketSellShares > 0 && this.selectedOption) {
      const currentPrice = this.isFirstOutcomeSelected() ? this.lastPriceYes / 100 : this.lastPriceNo / 100;
      return this.marketSellShares * currentPrice;
    }
    return 0;
  }

  // Calculate profit for Market Sell
  calculateMarketSellProfit(): number {
    // For Market Sell, profit is what you receive
    return this.calculateMarketSellReceiveAmount();
  }

  // Calculate change for Market Sell
  calculateMarketSellChange(): number {
    if (this.selectedOption) {
      const currentPrice = this.isFirstOutcomeSelected() ? this.lastPriceYes : this.lastPriceNo;
      return ((100 - currentPrice) / currentPrice) * 100;
    }
    return 0;
  }

  // Calculate multiplier for Market Sell
  calculateMarketSellMultiplier(): number {
    if (this.selectedOption) {
      const currentPrice = this.isFirstOutcomeSelected() ? this.lastPriceYes : this.lastPriceNo;
      return 100 / currentPrice;
    }
    return 0;
  }

  // Calculate market impact for Market Sell
  calculateMarketSellImpact(): number {
    if (this.marketSellShares > 0 && this.selectedOption) {
      // Example calculation - adjust based on your logic
      const basePrice = this.isFirstOutcomeSelected() ? this.lastPriceYes : this.lastPriceNo;
      return (this.marketSellShares / 100) * 0.1; // Example: 0.1% impact per 100 shares
    }
    return 0;
  }


  toggleExpirationDropdown() {
    this.showExpirationDropdown = !this.showExpirationDropdown;
    // In the mobile trade sheet the field can sit close to the bottom edge —
    // nudge the open list into view so every option stays reachable.
    if (this.showExpirationDropdown) {
      setTimeout(() => this.expirationList?.nativeElement.scrollIntoView({ block: 'nearest', behavior: 'smooth' }));
    }
  }

  selectExpirationOption(option: string) {
    this.selectExpirationType = option;
    this.showExpirationDropdown = false;
  }

  clearExpirationOption(event: Event) {
    event.stopPropagation();
    this.selectExpirationType = '';
    this.showExpirationDropdown = false;
  }

  // Dynamic loadTopHolders supporting multiple outcomes
  loadTopHolders(marketID: string, isLoadMore: boolean = false): void {
    if (this.isLoadingHolders) return;

    if (!isLoadMore) {
      this.outcomesHolders = [];
    }

    this.isLoadingHolders = true;

    this.service.getTopHolders(marketID, 1, this.PAGE_SIZE).subscribe({
      next: (res: TopHoldersResponse) => {
        if (res && res.data) {
          this.outcomesHolders = res.data.map((outcome: OutcomeData) => ({
            title: outcome.outcome_title,
            holders: (outcome.top_holders || []).map((h: any) => this.getTooltipHolderFromPosition(h)),
            hasMore: (outcome.top_holders || []).length === this.PAGE_SIZE,
            isLoading: false
          }));
          this.syncSelectedHolderOutcome();
        }
        this.isLoadingHolders = false;
      },
      error: (err: Error) => {
        console.error("Error fetching top holders:", err);
        this.isLoadingHolders = false;
      }
    });
  }

  // ---- Top Holders outcome picker (mobile only, <= 575px) ----

  // Desktop lays every outcome out side by side; at <= 575px a multi-outcome
  // market has too many columns for that, so the picker narrows it to one.
  get displayedHolderGroups(): any[] {
    if (!this.isHoldersMobileView || !this.isMultiOutcomeFlag()) {
      return this.outcomesHolders;
    }

    const selected = this.outcomesHolders.find(
      (group: any) => group.title === this.selectedHolderOutcomeTitle
    );

    return selected ? [selected] : this.outcomesHolders.slice(0, 1);
  }

  get showHoldersOutcomePicker(): boolean {
    return this.isMultiOutcomeFlag() && this.outcomesHolders.length > 1;
  }

  get selectedHolderOutcomeLabel(): string {
    return this.selectedHolderOutcomeTitle || this.outcomesHolders[0]?.title || '';
  }

  private syncSelectedHolderOutcome(): void {
    const stillListed = this.outcomesHolders.some(
      (group: any) => group.title === this.selectedHolderOutcomeTitle
    );

    if (!stillListed) {
      this.selectedHolderOutcomeTitle = this.outcomesHolders[0]?.title ?? null;
    }
  }

  toggleHoldersOutcomeDropdown(): void {
    this.showHoldersOutcomeDropdown = !this.showHoldersOutcomeDropdown;
    if (this.showHoldersOutcomeDropdown) {
      this.updateHoldersOutcomeDropdownPlacement();
    }
  }

  /**
   * Keeps the outcome list clear of the fixed mobile tab bar, which otherwise
   * covers the options at the end of the list.
   */
  private updateHoldersOutcomeDropdownPlacement(): void {
    const trigger = this.holdersOutcomeTrigger?.nativeElement;
    if (!trigger) {
      return;
    }

    const placement = measureDropdownPlacement(trigger, { maxHeight: this.holdersOutcomeDropdownCap });
    this.holdersOutcomeDropUp = placement.above;
    this.holdersOutcomeDropdownMaxHeight = placement.maxHeight;
  }

  selectHolderOutcome(group: any): void {
    this.selectedHolderOutcomeTitle = group?.title ?? null;
    this.showHoldersOutcomeDropdown = false;
  }

  loadActivity(isLoadMore: boolean = false) {
    // Reset pagination when doing a fresh load
    if (!isLoadMore) {
      this.activityPage = 1;
      this.activityList = [];
      this.hasMoreActivity = true;
    }

    if (this.isLoadingActivity || !this.hasMoreActivity) {
      return;
    }

    this.isLoadingActivity = true;
    this.service.getMarketActivity(this.marketID, null, this.activityPage, this.PAGE_SIZE, this.selectedMinAmount).subscribe({
      next: (res) => {
        const newActivity = res.data.results || [];

        if (isLoadMore) {
          this.activityList = [...this.activityList, ...newActivity];
        } else {
          this.activityList = newActivity;
        }

        // Check if there are more records
        this.hasMoreActivity = newActivity.length === this.PAGE_SIZE;
        this.activityPage++;
        this.isLoadingActivity = false;
        // console.log("Activity:", res);
      },
      error: (err) => {
        console.error(err);
        this.isLoadingActivity = false;
      }
    });
  }

  /**
   * The name an activity row is filed under. A wallet address is cut to
   * 0x0f51...2ceb - four hex characters is as much as the row has width for -
   * while a chosen username is left as it is.
   * @param item - The activity record the API returned
   */
  getActivityActorName(item: any): string {
    const name = item?.user_name || item?.username || item?.name || item?.activity_text?.split(' ')[0] || 'User';

    return shortenWalletAddress(name, ACTIVITY_ADDRESS_HEX) || name;
  }

  /**
   * The trade behind one activity row - quantity, outcome, the price of a single
   * share and the total, each named separately so the row can say which is which.
   * Read from the sentence itself: the record's `market_name` is the question the
   * market asks, not the outcome the shares are on.
   * @param item - The activity record the API returned
   */
  getActivityTrade(item: any): ActivityTrade {
    return parseActivityTrade(item?.activity_text || '');
  }

  /**
   * The name a Top Holders row is filed under. A wallet address is cut to
   * 0x0f...f4b6 - the first four characters and the last four, which is as much
   * as the column has room for - while a chosen username is left as it is.
   * @param holder - The holder record the API returned
   */
  getHolderDisplayName(holder: any): string {
    return shortenWalletAddress(holder?.user_name ?? '');
  }

  getTooltipHolderFromPosition(user: any): Holder {
    return {
      user_id: user?.user_id || user?.id || '',
      user_name: user?.user_name || user?.username || user?.name || 'User',
      shares: Number(user?.shares ?? 0),
      profile_picture: user?.profile_picture || user?.profile_image || user?.picture || '',
      joined_at: user?.joined_at || user?.created_at,
      created_at: user?.created_at,
      position_value: user?.positions ?? user?.position_value ?? user?.total_position_value,
      profit_loss: user?.profit_loss ?? user?.pnl ?? user?.pnl_value,
      volume: user?.volume ?? user?.total_volume ?? this.marketData?.volume,
      avg_buy_price: user?.avg_buy_price
    };
  }

  isLoss(value: any): boolean {
    if (value === undefined || value === null || value === '') return false;
    return Number(value) < 0;
  }

  getTooltipHolderFromActivity(item: any): Holder {
    return {
      user_id: item?.user_id || item?.id || '',
      user_name: this.getActivityActorName(item),
      shares: Number(item?.shares ?? 0),
      profile_picture: item?.profile_picture || item?.profile_image || item?.picture || '',
      joined_at: item?.joined_at || item?.created_at,
      created_at: item?.created_at,
      position_value: item?.positions ?? item?.position_value ?? item?.amount ?? item?.shares,
      profit_loss: item?.profit_loss ?? item?.pnl ?? item?.pnl_value,
      volume: item?.volume ?? item?.total_volume ?? this.marketData?.volume
    };
  }

  formatPrice(value: string | number | undefined): string {
    if (value === undefined || value === null) return '0.00';

    // Convert to number (handles the long strings from your API)
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num as number)) return '0.00';

    // Return absolute value for the label (since we handle the minus sign in HTML)
    // or use .toLocaleString if you want commas for thousands
    return Math.abs(num as number).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  loadPositions(isLoadMore: boolean = false) {
    // Reset pagination when doing a fresh load
    if (!isLoadMore) {
      this.yesPositionsPage = 1;
      this.noPositionsPage = 1;
      this.yesPositions = [];
      this.noPositions = [];
      this.hasMoreYesPositions = true;
      this.hasMoreNoPositions = true;
    }

    if ((this.isLoadingYesPositions || !this.hasMoreYesPositions) &&
      (this.isLoadingNoPositions || !this.hasMoreNoPositions)) {
      return;
    }

    this.isLoadingYesPositions = true;
    this.isLoadingNoPositions = true;

    const statusParam = this.selectedStatus === PositionStatus.ALL ? undefined : this.selectedStatus;
    this.service.getMarketPositions(this.marketID, statusParam, this.selectedSort, this.yesPositionsPage, this.PAGE_SIZE)
      .subscribe((response: any) => {
        if (response?.data?.results) {
          const yesResult = response.data.results.find(
            (r: any) => r.outcome_title.toUpperCase() === 'YES'
          );
          const noResult = response.data.results.find(
            (r: any) => r.outcome_title.toUpperCase() === 'NO'
          );

          const newYesPositions = (yesResult ? yesResult.users_list : []).map((u: any) => this.getTooltipHolderFromPosition(u));
          const newNoPositions = (noResult ? noResult.users_list : []).map((u: any) => this.getTooltipHolderFromPosition(u));

          if (isLoadMore) {
            this.yesPositions = [...this.yesPositions, ...newYesPositions];
            this.noPositions = [...this.noPositions, ...newNoPositions];
          } else {
            this.yesPositions = newYesPositions;
            this.noPositions = newNoPositions;
          }

          // Check if there are more records
          this.hasMoreYesPositions = newYesPositions.length === this.PAGE_SIZE;
          this.hasMoreNoPositions = newNoPositions.length === this.PAGE_SIZE;
          this.yesPositionsPage++;
          this.noPositionsPage++;
        } else {
          if (!isLoadMore) {
            this.yesPositions = [];
            this.noPositions = [];
          }
        }
        this.isLoadingYesPositions = false;
        this.isLoadingNoPositions = false;
      });
  }

  selectOutcome(outcome: any) {
    this.outcomeId = outcome.id;
    this.marketID = outcome.market_id;

    this.loadOrderBook();
    this.initializeMarketPrices();
  }

  loadOrderBook(outcomeId?: string) {

    const id = outcomeId || this.selectedOutcomeId;

    if (!id) {
      console.log("Outcome ID not available");
      return;
    }

    this.startOrderBookStream(this.marketID, id);
  }

  startOrderBookStream(marketId: string, outcomeId: string) {
    if (this.orderBookStreamSub) {
      this.orderBookStreamSub.unsubscribe();
    }

    this.orderBookStreamSub = this.service.streamMarketOrderbook(marketId, outcomeId)
      .subscribe({
        next: (res: any) => {
          // The response might be the direct object or wrapped in a data property
          const data = res.data || res;

          // Ignore ping or empty events
          if (!data.asks && !data.bids) return;

          // ASK ORDERS
          this.asks = (data.asks || []).map((item: any) => ({
            ...item,
            price: Math.round(Number(item.price) * 100),
            shares: parseFloat(item.open_shares),
            total: parseFloat(item.total)
          }));

          // BID ORDERS
          this.bids = (data.bids || []).map((item: any) => ({
            ...item,
            price: Math.round(Number(item.price) * 100),
            shares: parseFloat(item.open_shares),
            total: parseFloat(item.total)
          }));

          // ✅ SORT BEFORE cumulative
          // Asks → highest price first (top to bottom like Polymarket)
          this.asks = this.asks.sort((a: any, b: any) => b.price - a.price);
          // Bids → highest price first
          this.bids = this.bids.sort((a: any, b: any) => b.price - a.price);

          let cumulativeAsk = 0;
          this.asks = this.asks
            .reverse()
            .map((item: any) => {
              cumulativeAsk += item.total;
              return {
                ...item,
                cumulativeTotal: cumulativeAsk
              };
            }).reverse();


          let cumulativeBid = 0;
          this.bids = this.bids.map((item: any) => {
            cumulativeBid += item.total;
            return {
              ...item,
              cumulativeTotal: cumulativeBid
            };
          });

          // =========================
          // MAX DEPTH (FOR UI WIDTH)
          // =========================

          const maxAskDepth = Math.max(...this.asks.map(x => x.cumulativeTotal));
          const maxBidDepth = Math.max(...this.bids.map(x => x.cumulativeTotal));

          this.maxDepth = Math.max(maxAskDepth, maxBidDepth);

          // TOTAL BID SHARES
          this.totalBid = this.bids.reduce(
            (sum: number, item: any) => sum + item.shares,
            0
          );

          // LAST PRICE / MID PRICE
          // Prefer 'last', fall back to 'mid' or 'best_ask'
          const priceValue = data.last_trade_price ?? data.last ?? data.mid ?? data.best_ask;
          const title = (data.outcome_title || '').toLowerCase();

          if (priceValue !== null && priceValue !== undefined && Number(priceValue) > 0) {
            const price = Math.round(Number(priceValue) * 100);
            this.lastPrice = price;
          }

          // SPREAD
          if (data.spread !== undefined) {
            this.spread = Math.round(parseFloat(data.spread) * 100);
          } else if (this.asks.length > 0 && this.bids.length > 0) {
            this.spread = this.asks[0].price - this.bids[0].price;
          }

          this.cdRef.detectChanges();

          if (!this.hasCentered) {
            setTimeout(() => {
              this.recenterOrderBook(); // 👈 IMPORTANT
              this.hasCentered = true; // ✅ mark as done
            }, 100);
          }
        },
        error: (err) => {
          console.error("Orderbook stream error:", err);
        }
      });
  }

  updateOrderBookPrices(prices: any) {
    if (!prices || !this.asks || !this.bids) return;

    // Example: update top ask/bid prices
    this.asks = this.asks.map(ask => ({
      ...ask,
      price: prices.yes ?? ask.price
    }));

    this.bids = this.bids.map(bid => ({
      ...bid,
      price: prices.no ?? bid.price
    }));

    // Optionally recalc totals
    this.asks.forEach(a => a.total = (a.price * a.shares) / 100);
    this.bids.forEach(b => b.total = (b.price * b.shares) / 100);

    // Update derived values
    if (prices.yes !== undefined) {
      this.lastPrice = prices.yes;
    }
    if (this.asks.length > 0 && this.bids.length > 0) {
      this.spread = this.asks[0].price - this.bids[0].price;
    }
  }

  get isBinaryMarket(): boolean {
    if (!this.marketData || !this.marketData.outcomes) return false;
    // Typically binary markets have exactly 2 outcomes: "Yes" and "No"
    return this.marketData.outcomes.length === 2;
  }

  isMultiOutcomeFlag(): boolean {
    // console.log("check");
    return this.marketData?.outcome_type === 'MULTIPLE';
  }

  loadPriceHistory(interval: string = 'ALL') {
    const marketId = this.marketID;
    const outcomeId = this.selectedOutcomeId;

    if (!marketId || !outcomeId) return;

    this.service.getMarketPriceHistory(marketId, outcomeId, interval)
      .subscribe({
        next: (res: any) => {

          let points = res?.data?.data?.points || [];

          if (points.length === 0) {
            // For new markets with no history, provide fallback points to show a flat line
            const now = Math.floor(Date.now() / 1000);
            const initialPrice = (this.lastPriceYes || 50) / 100;
            points = [
              { time: now - 3600, value: initialPrice },
              { time: now, value: initialPrice }
            ];
          }

          const mapHistory = (h: any[], isYes: boolean): ChartPoint[] =>
            (h
              .map((item: any): ChartPoint | null => {
                if (item.time === undefined || item.value === undefined) return null;

                const time = Number(item.time);
                let value = Number(item.value);

                if (value <= 1) value = value * 100;
                if (!isYes) value = 100 - value;

                return { time, value };
              })
              .filter((i): i is ChartPoint => i !== null) as ChartPoint[])
              .sort((a: ChartPoint, b: ChartPoint) => a.time - b.time);
          this.priceHistoryData = {
            yes: mapHistory(points, true),
            no: mapHistory(points, false),
          };
        },
        error: (err: any) => {
          console.error('Error fetching price history:', err);
        }
      });
  }

  isMarketClosed(): boolean {
    if (!this.marketData?.resolution_state) return false;

    // Normalize the string: remove spaces and make it uppercase
    const state = String(this.marketData.resolution_state).trim().toUpperCase();

    return [
      ResolutionState.MARKET_EXPIRED,
      ResolutionState.WINNER_DECLARED,
      ResolutionState.SCHEDULED
    ].includes(state as ResolutionState);
  }

  isMarketWinnerDeclared(): boolean {
    if (!this.marketData?.resolution_state) return false;

    // Normalize the string: remove spaces and make it uppercase
    const state = String(this.marketData.resolution_state).trim().toUpperCase();

    return [
      ResolutionState.WINNER_DECLARED
    ].includes(state as ResolutionState);
  }

  getWinnerOutcome(): String {
    return this.marketData?.winner_outcome || '';
  }

  initializeMarketPrices() {
    if (this.isBinaryMarket) {
      // Only for new markets
      this.lastPriceYes = this.lastPriceYes ?? 50; // default 50
      this.lastPriceNo = this.lastPriceNo ?? 50;   // default 50

      // Also update limitPrice if selectedOption is already chosen
      if (this.isFirstOutcomeSelected()) {
        this.limitPrice = this.lastPriceYes / 100;
      } else if (!this.isFirstOutcomeSelected()) {
        this.limitPrice = this.lastPriceNo / 100;
      }
    }
  }

  calculateExpiration(option: string): number {
    // IF THE USER DOESN'T SELECT ANYTHING:
    if (!option) {
      if (this.marketData?.end_date) {
        return Math.floor(new Date(this.marketData.end_date).getTime() / 1000);
      }
      // If user selects something, handle differently (if needed)
      return 0;  // or your logic for selected option
    }
    const now = Math.floor(Date.now() / 1000);
    const oneHour = 3600;

    switch (option) {
      case ExpirationType.FIVE_MINUTES:
        return now + 300;
      case ExpirationType.ONE_HOUR:
        return now + oneHour;
      case ExpirationType.FIVE_MINUTES:
        return now + (5 * oneHour);
      case ExpirationType.TWELVE_HOURS:
        return now + (12 * oneHour);
      case ExpirationType.TWENTY_FOUR_HOURS:
        return now + (24 * oneHour);

      case ExpirationType.END_OF_DAY:
        const eod = new Date();
        // Sets time to 23:59:59 (End of Day)
        eod.setHours(23, 59, 59, 999);
        return Math.floor(eod.getTime() / 1000);

      default:
        return 0; // Blockchain standard for no expiry
    }
  }

  recenterOrderBook() {
    const container = this.orderBookContainer?.toArray()[0]?.nativeElement;
    const middle = this.middleInfo?.toArray()[0]?.nativeElement;

    if (!container || !middle) return; // ✅ prevent error

    // ✅ STEP 1: Let DOM settle first
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {

        // ✅ USE offsetTop (real position in scroll flow)
        const middleOffset = middle.offsetTop;

        const containerHeight = container.clientHeight;
        const middleHeight = middle.clientHeight;

        const scrollTo = middleOffset - (containerHeight / 2) + (middleHeight / 2);

        const isAlreadyCentered = Math.abs(container.scrollTop - scrollTo) < 5;
        console.log("already scrolled:", isAlreadyCentered);
        if (!isAlreadyCentered) {
          container.scrollTo({
            top: scrollTo,
            behavior: 'smooth'
          });
        }
      });
    });
  }
}
